"use strict";

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError(
            "Super expression must either be null or a function"
        );
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: { value: subClass, writable: true, configurable: true },
    });
    Object.defineProperty(subClass, "prototype", { writable: false });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    } else if (call !== void 0) {
        throw new TypeError(
            "Derived constructors may only return object or undefined"
        );
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
        );
    }
    return self;
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError(
                "Super expression must either be null or a function"
            );
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(
                Class,
                arguments,
                _getPrototypeOf(this).constructor
            );
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true,
            },
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
        _construct = Reflect.construct.bind();
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [null];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(
            Reflect.construct(Boolean, [], function () {})
        );
        return true;
    } catch (e) {
        return false;
    }
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf
        ? Object.setPrototypeOf.bind()
        : function _setPrototypeOf(o, p) {
              o.__proto__ = p;
              return o;
          };
    return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf
        ? Object.getPrototypeOf.bind()
        : function _getPrototypeOf(o) {
              return o.__proto__ || Object.getPrototypeOf(o);
          };
    return _getPrototypeOf(o);
}
function _slicedToArray(arr, i) {
    return (
        _arrayWithHoles(arr) ||
        _iterableToArrayLimit(arr, i) ||
        _unsupportedIterableToArray(arr, i) ||
        _nonIterableRest()
    );
}
function _nonIterableRest() {
    throw new TypeError(
        "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
    );
}
function _iterableToArrayLimit(arr, i) {
    var _i =
        null == arr
            ? null
            : ("undefined" != typeof Symbol && arr[Symbol.iterator]) ||
              arr["@@iterator"];
    if (null != _i) {
        var _s,
            _e,
            _x,
            _r,
            _arr = [],
            _n = !0,
            _d = !1;
        try {
            if (((_x = (_i = _i.call(arr)).next), 0 === i)) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else
                for (
                    ;
                    !(_n = (_s = _x.call(_i)).done) &&
                    (_arr.push(_s.value), _arr.length !== i);
                    _n = !0
                );
        } catch (err) {
            (_d = !0), (_e = err);
        } finally {
            try {
                if (
                    !_n &&
                    null != _i["return"] &&
                    ((_r = _i["return"]()), Object(_r) !== _r)
                )
                    return;
            } finally {
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it =
        (typeof Symbol !== "undefined" && o[Symbol.iterator]) ||
        o["@@iterator"];
    if (!it) {
        if (
            Array.isArray(o) ||
            (it = _unsupportedIterableToArray(o)) ||
            (allowArrayLike && o && typeof o.length === "number")
        ) {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return { done: true };
                    return { done: false, value: o[i++] };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F,
            };
        }
        throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
        );
    }
    var normalCompletion = true,
        didErr = false,
        err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally {
                if (didErr) throw err;
            }
        },
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly &&
            (symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            })),
            keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2
            ? ownKeys(Object(source), !0).forEach(function (key) {
                  _defineProperty(target, key, source[key]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(
                  target,
                  Object.getOwnPropertyDescriptors(source)
              )
            : ownKeys(Object(source)).forEach(function (key) {
                  Object.defineProperty(
                      target,
                      key,
                      Object.getOwnPropertyDescriptor(source, key)
                  );
              });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true,
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return (
        (_typeof =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (obj) {
                      return typeof obj;
                  }
                : function (obj) {
                      return obj &&
                          "function" == typeof Symbol &&
                          obj.constructor === Symbol &&
                          obj !== Symbol.prototype
                          ? "symbol"
                          : typeof obj;
                  }),
        _typeof(obj)
    );
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(
            target,
            _toPropertyKey(descriptor.key),
            descriptor
        );
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", { writable: false });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/* eslint-disable */
/* ==================================================
#Logo list
#Featured collection
#Featured promotions
#Slideshow
#Testimonials
#Gallery
#Video
#Cart
#Product
#Header
#Map
#Shoppable Image
#Global accordions
#Global shortcodes

/*============================================================================
  Logo list
==============================================================================*/

window.logoList = {
    init: function init() {
        $("[data-logo-slider]").flickity({
            cellAlign: "center",
            pageDots: false,
            prevNextButtons: true,
            contain: true,
            groupCells: true,
            initialIndex: 0,
        });
    },
    unload: function unload(target) {
        if ($(target).hasClass("flickity-enabled")) {
            $(target).flickity("destroy");
        }
    },
};

/*============================================================================
  Featured collection
==============================================================================*/

window.featuredCollection = {
    init: function init() {
        $(".js-product-slider .products-slider").each(function (index, value) {
            var productsPerSlide = $(value).data("products-per-slide");
            var productsLimit = $(value).data("products-limit");
            var productsAvailable = $(value).data("products-available");
            var cellAlign = "";
            var draggable = false;
            var prevNext = false;
            var wrapAround = false;
            var initialIndex = 0;

            // Ensure product media libraries are present
            window.Shopify.loadFeatures(
                [
                    {
                        name: "shopify-xr",
                        version: "1.0",
                    },
                    {
                        name: "model-viewer-ui",
                        version: "1.0",
                    },
                ],
                window.productMedia.setupMedia
            );
            if (
                (productsPerSlide === "2" &&
                    productsAvailable > productsPerSlide &&
                    productsLimit > productsPerSlide) ||
                (productsPerSlide === "4" &&
                    productsAvailable > productsPerSlide &&
                    productsLimit > productsPerSlide) ||
                (productsPerSlide === "6" &&
                    productsAvailable > productsPerSlide &&
                    productsLimit > productsPerSlide)
            ) {
                cellAlign = "left";
            } else {
                cellAlign = "center";
            }
            if (
                productsAvailable > productsPerSlide &&
                productsLimit > productsPerSlide
            ) {
                draggable = true;
                prevNext = true;
                wrapAround = true;
            } else {
                draggable = false;
                prevNext = false;
                wrapAround = false;
            }
            if (
                (productsPerSlide === "2" &&
                    productsAvailable > productsPerSlide) ||
                (productsPerSlide === "4" &&
                    productsAvailable > productsPerSlide) ||
                (productsPerSlide === "6" &&
                    productsAvailable > productsPerSlide)
            ) {
                initialIndex = 0;
            } else if (productsPerSlide === "3" && productsAvailable) {
                initialIndex = 1;
            } else if (productsPerSlide === "5" && productsAvailable) {
                initialIndex = 2;
            } else if (productsPerSlide === "7" && productsAvailable) {
                initialIndex = 3;
            }
            if (window.PXUTheme.media_queries.medium.matches) {
                cellAlign = "center";
                draggable = true;
                prevNext = true;
                wrapAround = true;
                initialIndex = 1;
                $(value)
                    .parents(".even-num-slides")
                    .removeClass("even-num-slides");
            }
            $(value).flickity({
                lazyLoad: 2,
                imagesLoaded: true,
                draggable: draggable,
                prevNextButtons: prevNext,
                wrapAround: wrapAround,
                cellAlign: cellAlign,
                pageDots: window.usePageDots,
                contain: true,
                freeScroll: true,
                arrowShape: window.arrowSize,
                initialIndex: initialIndex,
            });
            $(value).addClass("slider-initialized");
        });
    },
    unload: function unload($target) {
        var $slider = $target.find(".js-product-slider");
        if ($slider.hasClass("flickity-enabled")) {
            $slider.flickity("destroy");
        }
    },
};

/*============================================================================
  Featured promotions
==============================================================================*/
window.featuredPromotions = {
    init: function init() {
        $(".feature-overlay").hover(
            function () {
                $(this)
                    .find(".feature-details")
                    .slideDown("100", function () {
                        $(this).addClass("reveal-details");
                    });
            },
            function () {
                $(this).find(".feature-details").removeClass("reveal-details");
                $(this).find(".feature-details").slideUp("100");
            }
        );
        $(".js-featured-promotions").each(function () {
            var $promos = $(this);
            var animationStyle = $(this).data("promo-animation");
            $promos.waypoint(
                function () {
                    $(this.element)
                        .find(".feature-section")
                        .addClass("animated ".concat(animationStyle));
                },
                {
                    offset: "80%",
                }
            );
        });
    },
};

/*============================================================================
  Slideshow
==============================================================================*/

window.slideshow = {
    init: function init() {
        $(".js-homepage-slideshow").each(function () {
            var $homepageSlider = $(this);
            var settings = {
                slideshowSpeed: $homepageSlider.data("slideshow-speed") * 1000,
                slideshowTextAnimation: $homepageSlider.data(
                    "slideshow-text-animation"
                ),
                adaptiveHeight: $homepageSlider.data("adaptive-height"),
            };

            // Initiate the slideshow
            if (!$homepageSlider.hasClass("flickity-enabled")) {
                var arrowShow =
                    $homepageSlider.find(".gallery-cell").length === 1
                        ? false
                        : true;
                $homepageSlider.flickity({
                    adaptiveHeight: settings.adaptiveHeight,
                    wrapAround: true,
                    cellAlign: "left",
                    imagesLoaded: true,
                    prevNextButtons: arrowShow,
                    draggable: arrowShow,
                    autoPlay: settings.slideshowSpeed,
                });
                if (settings.slideshowTextAnimation !== "") {
                    var flkty = $homepageSlider.data("flickity");
                    setTimeout(function () {
                        $homepageSlider
                            .find(".gallery-cell:nth-child(1) .caption-content")
                            .addClass(
                                "animated ".concat(
                                    settings.slideshowTextAnimation
                                )
                            );
                    }, 400);
                    $homepageSlider.on("select.flickity", function () {
                        if ($homepageSlider.is(":visible")) {
                            var currentSlide = flkty.selectedIndex + 1;
                            setTimeout(function () {
                                $homepageSlider
                                    .find(".caption-content")
                                    .removeClass(
                                        "animated ".concat(
                                            settings.slideshowTextAnimation
                                        )
                                    );
                                $homepageSlider
                                    .find(
                                        ".gallery-cell:nth-child(".concat(
                                            currentSlide,
                                            ") .caption-content"
                                        )
                                    )
                                    .addClass(
                                        "animated ".concat(
                                            settings.slideshowTextAnimation
                                        )
                                    );
                            }, 400);
                        }
                    });
                }
            }
            if ($homepageSlider.find(".gallery-cell").length > 1) {
                $homepageSlider.addClass("multi-image");
            } else {
                $homepageSlider.addClass("single-image");
            }
        });
    },
    unload: function unload($target) {
        var $slider = $target.find(".js-homepage-slideshow");
        $slider.flickity("destroy");
    },
};

/*============================================================================
  Testimonials
==============================================================================*/

window.testimonials = {
    init: function init() {
        $(".js-testimonial").each(function () {
            var $testimonialSlider = $(this);
            var settings = {
                slideshowSpeed:
                    $testimonialSlider.data("slideshow-speed") * 1000,
                slideshowTextAnimation: $testimonialSlider.data(
                    "slideshow-text-animation"
                ),
                adaptiveHeight: $testimonialSlider.data("adaptive-height"),
            };
            if ($(".testimonial-image").length > 0) {
                $(".testimonial-block").each(function () {
                    if ($(this).find(".testimonial-image").length === 0) {
                        var theBlock = $(this).closest(".testimonial-block");
                        $(theBlock).addClass("set-testimonial-height");
                    }
                });
            }

            // Initiate the slideshow
            if (!$testimonialSlider.hasClass("flickity-enabled")) {
                var arrowShow =
                    $testimonialSlider.find(".gallery-cell").length === 1
                        ? false
                        : true;
                $testimonialSlider.flickity({
                    adaptiveHeight: settings.adaptiveHeight,
                    wrapAround: true,
                    cellAlign: "left",
                    imagesLoaded: true,
                    prevNextButtons: arrowShow,
                    draggable: arrowShow,
                    autoPlay: settings.slideshowSpeed,
                });
                if (settings.slideshowTextAnimation !== "") {
                    var flkty = $testimonialSlider.data("flickity");
                    setTimeout(function () {
                        $testimonialSlider
                            .find(".gallery-cell:nth-child(1) .caption-content")
                            .addClass(
                                "animated ".concat(
                                    settings.slideshowTextAnimation
                                )
                            );
                    }, 400);
                    $testimonialSlider.on("select.flickity", function () {
                        if ($testimonialSlider.is(":visible")) {
                            var currentSlide = flkty.selectedIndex + 1;
                            setTimeout(function () {
                                $testimonialSlider
                                    .find(".caption-content")
                                    .removeClass(
                                        "animated ".concat(
                                            settings.slideshowTextAnimation
                                        )
                                    );
                                $testimonialSlider
                                    .find(
                                        ".gallery-cell:nth-child(".concat(
                                            currentSlide,
                                            ") .caption-content"
                                        )
                                    )
                                    .addClass(
                                        "animated ".concat(
                                            settings.slideshowTextAnimation
                                        )
                                    );
                            }, 400);
                        }
                    });
                }
            }
            if ($testimonialSlider.find(".gallery-cell").length > 1) {
                $testimonialSlider.addClass("multi-image");
            } else {
                $testimonialSlider.addClass("single-image");
            }
        });
    },
    unload: function unload($target) {
        var $slider = $target.find(".js-testimonial");
        $slider.flickity("destroy");
    },
};

/*============================================================================
  Gallery
==============================================================================*/

window.gallery = {
    init: function init() {
        $(".gallery-horizontal")
            .find(".gallery-image-wrapper")
            .each(function () {
                var wrapper = $(this);
                var images = $(this).find("img");
                var imgWidth;
                var imgHeight;
                $("<img />")
                    .attr("src", $(images).attr("src"))
                    .on("load", function () {
                        imgWidth = this.width;
                        imgHeight = this.height;
                        $(wrapper).css(
                            "flex-basis",
                            (imgWidth * 200) / imgHeight
                        );
                        $(wrapper).css(
                            "flex-grow",
                            (imgWidth * 200) / imgHeight
                        );
                        $(wrapper)
                            .find("i")
                            .css(
                                "padding-bottom",
                                "".concat((imgHeight / imgWidth) * 100, "%")
                            );
                    });
            });
        if ($("[rel=gallery]").length) {
            $("[rel=gallery]").fancybox({
                baseClass: "gallery-section__lightbox",
                clickContent: "nextOrClose",
                afterShow: function afterShow() {
                    // Loop through fancybox images, add alt attributes
                    var fancyImages = $(".fancybox-image");
                    $(".gallery__image").each(function (index, image) {
                        var $image = $(image);
                        var alt = $image.attr("alt");
                        fancyImages.eq(index).attr("alt", alt);
                    });
                },
            });
        }
    },
};

/*============================================================================
  Video
==============================================================================*/
window.video = {
    init: function init() {
        // Set up plyr for newly embedded video
        var featuredVideos = $("[data-video-element]").get();
        var featuredVideoPlayers = Plyr.setup(featuredVideos, {
            controls: window.videoControls,
            fullscreen: {
                enabled: true,
                fallback: true,
                iosNative: true,
            },
            storage: {
                enabled: false,
            },
        });

        // Adds plyr video id to video wrapper
        $.each(featuredVideoPlayers, function (index, player) {
            var id = player.id;
            var $video;
            if (player.isHTML5) {
                $video = $(player.elements.wrapper).find("video");
                $video.attr("data-plyr-video-id", id);
            }

            // When a video is playing, pause any other instances
            player.on("play", function (event) {
                var instance = event.detail.plyr;
                $.each(featuredVideoPlayers, function (index, player) {
                    if (instance.id != player.id) {
                        player.pause();
                    }
                });
            });

            // Moves players from video section into global array
            if (window.globalVideoPlayers) {
                window.globalVideoPlayers.push(player);
            }
        });
        $("[data-video-element]").each(function (index, video) {
            // Variables
            var $video = $(video);
            var $section = $video.parents(".shopify-section").attr("id", id);
            var $videoElement = $section.find($video);
            var $videoWrapper = $videoElement.parents(".video-wrapper");
            var $playButton = $videoWrapper.find("[data-play-button]");
            var $secondaryButton = $videoWrapper.find(
                "[data-secondary-button]"
            );
            var $videoText = $videoWrapper.find("[data-video-text]");
            var $videoTextContainer = $videoWrapper.find(
                "[data-video-text-container]"
            );
            var $image = $videoWrapper.find(".video-wrapper__image");
            var $posterImage = $videoWrapper.data("poster-image-uploaded");
            var aspectRatio = $videoWrapper.data("aspect-ratio");
            var id = $videoWrapper.data("video-src");
            var isAutoplay = $videoWrapper.data("autoplay");
            var isLoopingEnabled = $videoWrapper.data("autoloop");
            var isMuted = $videoWrapper.data("mute-video");
            $.each(featuredVideoPlayers, function (index, player) {
                var videoID;
                var playerID;
                if (player.isYouTube || player.isVimeo) {
                    var videoID = $videoWrapper.attr("id");
                    var playerID = $(player.elements.original).attr("id");
                } else if (player.isHTML5) {
                    var videoID = $videoWrapper
                        .find("[data-plyr-video-id]")
                        .data("plyr-video-id");
                    var playerID = player.id;
                    $videoElement = $section.find(".plyr--video");
                }
                if (playerID == videoID) {
                    // Reset play button icon
                    $videoWrapper.removeClass("play-button-icon--visible");

                    // Autoplay
                    if (isAutoplay) {
                        // If on desktop or player is YouTube/Vimeo
                        if (
                            window.PXUTheme.media_queries.large.matches ||
                            player.isYouTube ||
                            player.isVimeo
                        ) {
                            player.autoplay = true;

                            // Hide image
                            $image.hide();

                            // Show video
                            $videoElement.show();

                            // If display text over video unchecked
                            if (
                                $videoTextContainer.hasClass(
                                    "display-text-over-video--false"
                                )
                            ) {
                                $videoText.hide();
                            } else {
                                $videoText.show();
                            }

                            // Keep play button hidden
                            $playButton.hide();

                            // HTML5 Mobile Video
                        } else if (
                            window.PXUTheme.media_queries.medium.matches &&
                            player.isHTML5
                        ) {
                            // Hide image
                            $image.hide();

                            // Show video
                            $videoElement.show();

                            // Display button so that video can be played
                            $playButton.show();
                            player.on("play", function () {
                                // Show video
                                $videoElement.show();

                                // Hide play button
                                $playButton.hide();
                            });
                        }
                    } else {
                        // If Autoplay disabled
                        // If poster image, show image wrapper otherwise hide it
                        if ($posterImage) {
                            $image.show();
                            $videoElement.hide();
                        } else {
                            $videoElement.show();
                        }
                    }

                    // Clicking image will play video
                    $image.on("click", function () {
                        // Hide image
                        $(this).hide();

                        // Show video
                        $videoElement.show();
                        player.play();
                    });

                    // Muted
                    if (isMuted) {
                        player.muted = true;
                    }

                    // Aspect Ratio
                    if (aspectRatio) {
                        player.ratio = aspectRatio;
                    }

                    // Looping
                    if (isLoopingEnabled) {
                        player.loop = true;
                    }

                    // Show Video Controls
                    // - video controls get hidden using a css class: '.video-controls-enabled--false'

                    // If button exists, hide text and poster
                    if ($playButton) {
                        $playButton.on("click", function () {
                            // Play video
                            player.play();
                        });
                    }
                    player.on("statechange", function (event) {
                        //Check if unstarted when state changed and play if so
                        if (event.detail.code == "-1") {
                            player.play();
                        }
                    });
                    player.on("play", function () {
                        // Hide image
                        $image.hide();

                        // Reset play button icon
                        $videoWrapper.removeClass("play-button-icon--visible");

                        // Show video
                        $videoElement.show();

                        // If display text over video unchecked
                        if (
                            $videoTextContainer.hasClass(
                                "display-text-over-video--false"
                            )
                        ) {
                            $videoTextContainer.hide();
                        } else {
                            $videoTextContainer.show();
                        }

                        // Hide play button
                        if ($playButton) {
                            $playButton.hide();
                        }

                        // Hide secondary button
                        if ($secondaryButton) {
                            $secondaryButton.hide();
                        }
                    });

                    // If video is paused, show play button icon
                    player.on("pause", function () {
                        if (
                            $playButton.is(":hidden") ||
                            $playButton.length == 0
                        ) {
                            $videoWrapper.addClass("play-button-icon--visible");
                        }
                    });

                    // If page loads with video paused and no button showing, show icon
                    if (
                        (!player.playing && $playButton.is(":hidden")) ||
                        $playButton.length == 0
                    ) {
                        $videoWrapper.addClass("play-button-icon--visible");
                    }
                    return false;
                }
            });
        });
    },
};

/*============================================================================
  Cart
==============================================================================*/
window.cart = {
    init: function init() {
        if ($("#cart_form .tos_agree").length) {
            // Terms of service on cart page
            $("body").on(
                "click",
                "#cart_form input[type='submit']",
                function () {
                    if (
                        $(this)
                            .parents("form")
                            .find(".tos_agree")
                            .is(":checked")
                    ) {
                        $(this).submit();
                    } else {
                        var warning =
                            '<p class="warning animated bounceIn">'.concat(
                                window.PXUTheme.translation
                                    .agree_to_terms_warning,
                                "</p>"
                            );
                        if ($("p.warning").length === 0) {
                            $(this).before(warning);
                        }
                        return false;
                    }
                }
            );
        }
    },
};

/*============================================================================
  Product
==============================================================================*/
window.selectCallback = function (variant, selector, $element) {
    var evt = document.createEvent("HTMLEvents");
    var $product;
    if ($element) {
        $product = $element.find(".product-".concat(selector.product.id));
    } else {
        $product = $(".product-".concat(selector.product.id));
    }
    var $productForm = $(".product_form, .shopify-product-form", $product);
    var variantInventory = $productForm.data("variant-inventory");

    // Manually trigger change event so
    // pure JS listeners can receive it
    evt.initEvent("change", false, true);
    selector.variantIdField.dispatchEvent(evt);

    // Notify form

    var $notifyForm = $(".notify-form-".concat(selector.product.id));
    var productTitle = $notifyForm.data("product-title");
    var $notifyFormInputs = $(".notify_form__inputs", $product);
    var notifySend = window.PXUTheme.translation.notify_email_send;
    var notifyUrl = $notifyFormInputs.data("url");

    // Construct the notify message
    if (variant) {
        if (variant.title !== "Default Title") {
            // Escape the variant title
            window.variantTitle = variant.title.replace(/"/g, "&quot;");
            window.notifyMessage =
                window.PXUTheme.translation.notify_message_first +
                productTitle +
                " - " +
                window.variantTitle +
                window.PXUTheme.translation.notify_message_last +
                notifyUrl;
        } else {
            window.notifyMessage =
                window.PXUTheme.translation.notify_message_first +
                productTitle +
                window.PXUTheme.translation.notify_message_last +
                notifyUrl;
        }
    }

    // Prefill the email address if a customer is logged in
    var notifyFormEmail;
    var notifyFormPlaceholder;
    if ($notifyForm.hasClass("notify-form--customer")) {
        notifyFormEmail = $notifyForm.data("customer-email");
        notifyFormPlaceholder = "";
    } else {
        notifyFormEmail = "";
        notifyFormPlaceholder = window.PXUTheme.translation.notify_email;
    }

    // Compile HTML
    window.notifyFormHTML =
        '\n    <input\n      class="notify-email"\n      id="contact[email]"\n      name="contact[email]"\n      type="email"\n      placeholder="'
            .concat(notifyFormPlaceholder, '"\n      value="')
            .concat(
                notifyFormEmail,
                '"\n      required\n    >\n\n    <input\n      type="hidden"\n      name="challenge"\n      value="false"\n    >\n\n    <input\n      class="notify_form_message"\n      name="contact[body]"\n      type="hidden"\n      data-body="'
            )
            .concat(window.notifyMessage, '"\n      value="')
            .concat(
                window.notifyMessage,
                '"\n    >\n\n    <input\n      class="\n        global-button\n        global-button--primary\n      "\n      type="submit"\n      value="'
            )
            .concat(notifySend, '"\n    >\n  ');

    // Image Variant feature
    if (variant && variant.featured_image && $product.is(":visible")) {
        var $sliders = $(".js-product-gallery", $product);
        $sliders.each(function (_, slider) {
            var $slider = $(slider);
            var $sliderInstance = window.Flickity.data($slider[0]);
            if ($slider && $sliderInstance !== undefined) {
                var index = $(
                    '[data-image-id="'.concat(variant.featured_media.id, '"]')
                ).data("index");
                $sliderInstance.select(index, false, true);
            }
        });
    }

    // Toggles images in product slider when inline quickshop and layout set to slider
    if (variant && variant.featured_image && $product.is(":visible")) {
        if (
            window.PXUTheme.theme_settings.product_form_style === "select" &&
            window.PXUTheme.theme_settings.quick_shop_style === "inline"
        ) {
            var $selectedVariants = $(".products-slider")
                .find("select option:not(.selector-wrapper select option)")
                .filter(":selected");
            $selectedVariants.each(function toggleImage() {
                if ($(this).data("featured-image")) {
                    var swatchImage = $(this).data("image");
                    var $quickShopElement = $(this)
                        .parents(".thumbnail")
                        .find(".image__container img");
                    $quickShopElement.attr("src", swatchImage);
                    $quickShopElement.attr("srcset", swatchImage);
                }
            });
        }
    }
    if (variant) {
        if (variantInventory) {
            variantInventory.forEach(function (v) {
                if (v.id === variant.id) {
                    var currentVariant = variant;
                    currentVariant.inventory_quantity = v.inventory_quantity;
                    currentVariant.inventory_management =
                        v.inventory_management;
                    currentVariant.inventory_policy = v.inventory_policy;
                }
            });
        }
        $(".sku span", $product).text(variant.sku);
        if (window.PXUTheme.theme_settings.product_form_style === "radio") {
            var length = variant.options.length;
            for (var i = 0; i < length; i++) {
                var radioButton = $productForm.find(
                    '.swatch[data-option-index="'
                        .concat(escape(i), '"] :radio[value="')
                        .concat(variant.options[i].replace(/"/g, '\\"'), '"]')
                );
                if (radioButton.length) {
                    radioButton.get(0).checked = true;
                }
            }
        } else {
            $(".notify_form_message", $product).attr(
                "value",
                ""
                    .concat(
                        $(".notify_form_message", $product).data("body"),
                        " - "
                    )
                    .concat(window.variantTitle)
            );
        }
    }
    if (variant && variant.available === true) {
        if (variant.inventory_management && variant.inventory_quantity > 0) {
            if (window.PXUTheme.theme_settings.display_inventory_left) {
                if (variant.inventory_quantity === 1) {
                    window.itemsLeftText =
                        window.PXUTheme.translation.one_item_left;
                } else {
                    window.itemsLeftText =
                        window.PXUTheme.translation.items_left_text;
                }
                var inventoryThreshold = parseInt(
                    window.PXUTheme.theme_settings.inventory_threshold,
                    10
                );
                if (variant.inventory_quantity <= inventoryThreshold) {
                    $(".items_left", $product).html(
                        ""
                            .concat(variant.inventory_quantity, " ")
                            .concat(window.itemsLeftText)
                    );
                } else {
                    $(".items_left", $product).html("");
                }
            }
            if (window.PXUTheme.theme_settings.limit_quantity) {
                if (variant.inventory_policy === "deny") {
                    $(".quantity", $product).attr(
                        "max",
                        variant.inventory_quantity
                    );
                }
            }
        } else {
            $(".items_left", $product).text("");
            $(".quantity", $product).removeAttr("max");
        }
        $(".sold_out", $product).text("");
        $(".add_to_cart", $product)
            .removeClass("disabled")
            .removeAttr("disabled")
            .find("span")
            .text($(".add_to_cart", $product).data("label"));
        $(".shopify-payment-button", $product).removeClass("disabled");
        $(".purchase-details__buttons", $product).removeClass(
            "product-is-unavailable"
        );
        $(".modal_price", $product).removeClass("variant-unavailable");
        $product.find($notifyForm).hide();
        $product.find($notifyFormInputs).empty();
    } else {
        // When product is sold out
        var message = variant
            ? window.PXUTheme.translation.sold_out_text
            : window.PXUTheme.translation.unavailable_text;
        if (variant) {
            $(".modal_price", $product).removeClass("variant-unavailable");
        } else {
            // Add class to quickshop so we know variant is unavailable
            $(".modal_price", $product).addClass("variant-unavailable");
        }
        $(".items_left", $product).text("");
        $(".quantity", $product).removeAttr("max");
        $(".sold_out", $product).text(message);
        $(".purchase-details__buttons", $product).addClass(
            "product-is-unavailable"
        );
        $(".add_to_cart", $product)
            .addClass("disabled")
            .attr("disabled", "disabled")
            .find("span")
            .text(message);
        $(".shopify-payment-button", $product).addClass("disabled");
        $notifyForm.hide();
        $notifyFormInputs.empty();
        if (variant && !variant.available) {
            $notifyForm.fadeIn();
            $notifyFormInputs.empty();
            $notifyFormInputs.append(window.notifyFormHTML);
        }
    }
    if (window.PXUTheme.currency.show_multiple_currencies) {
        window.currencyConverter.convertCurrencies();
    }
};
window.productPage = {
    loadQuickshop: function loadQuickshop(url) {
        return window.shopifyAsyncview.load(
            url,
            // Template name
            {
                view: "quickshop",
            } // View name (suffix)
        );
    },
    init: function init() {
        window.Shopify.loadFeatures(
            [
                {
                    name: "shopify-xr",
                    version: "1.0",
                },
                {
                    name: "model-viewer-ui",
                    version: "1.0",
                },
            ],
            window.productMedia.setupMedia
        );

        // Call enable gallery function for product galleries
        $(
            "[data-product-gallery]:not(.product-recommendations [data-product-gallery])"
        ).each(function () {
            var $productGallery = $(this);
            window.productPage.enableGallery($productGallery);
        });
        if (window.location.search === "?contact_posted=true") {
            $(".notify-form .contact-form").hide();
            $(".notify-form .contact-form")
                .prev(".message")
                .html(window.PXUTheme.translation.notify_success_text);
        }
        if (window.PXUTheme.theme_settings.product_form_style === "radio") {
            $("body").on("change", ".swatch :radio", function swatchLogic() {
                var optionIndex = $(this)
                    .closest(".swatch")
                    .attr("data-option-index");
                var optionValue = $(this).val();
                var parentForm = $(this).closest(".product_form form");
                var notifyForm;
                if (parentForm.siblings(".notify-form").length) {
                    window.notifyForm = parentForm.siblings(".notify-form");
                } else {
                    window.notifyForm = $(".js-notify-form");
                }
                var option1 = parentForm
                    .find(".swatch_options input:checked")
                    .eq(0)
                    .val();
                var option2 =
                    parentForm
                        .find(".swatch_options input:checked")
                        .eq(1)
                        .val() || "";
                var option3 =
                    parentForm
                        .find(".swatch_options input:checked")
                        .eq(2)
                        .val() || "";
                var notifyMessage;
                if (option1 && option2 && option3) {
                    window.notifyMessage = ""
                        .concat(option1, " / ")
                        .concat(option2, " / ")
                        .concat(option3);
                } else if (option1 && option2) {
                    window.notifyMessage = ""
                        .concat(option1, " / ")
                        .concat(option2);
                } else {
                    window.notifyMessage = option1;
                }
                window.notifyForm
                    .find(".notify_form_message")
                    .attr(
                        "value",
                        ""
                            .concat(
                                window.notifyForm
                                    .find(".notify_form_message")
                                    .data("body"),
                                " - "
                            )
                            .concat(window.notifyMessage)
                    );
                $(this)
                    .closest("form")
                    .find(".single-option-selector")
                    .eq(optionIndex)
                    .val(optionValue)
                    .trigger("change");
            });
        }
        $(".js-product-gallery a").fancybox({
            width: 800,
            height: 800,
            baseClass: "product-section__lightbox",
            clickContent: false,
            afterShow: function afterShow(instance) {
                // Loop through fancybox images, add alt attributes
                var fancyImages = $(".fancybox-image");
                $(".product-gallery__image").each(function (index, image) {
                    var $image = $(image);
                    var alt = $image.attr("alt");
                    fancyImages.eq(index).attr("alt", alt);
                });
                var zoom = instance.$trigger
                    .first()
                    .parents(".js-product-gallery")
                    .data("zoom");
                if (zoom) {
                    $(".fancybox-image")
                        .last()
                        .wrap(
                            '<span class="zoom-wrap" style="display:inline-block"></span>'
                        )
                        .css("display", "block")
                        .parent()
                        .zoom({
                            touch: false,
                            magnify: 1,
                        });
                }
            },
            afterClose: function afterClose(instance) {
                var $instanceGallery = instance.$trigger
                    .first()
                    .parents(".js-product-gallery");
                $instanceGallery.hide();
                setTimeout(function () {
                    $instanceGallery.fadeIn(100);
                    $(".js-product-gallery").find(".is-selected a").focus();
                }, 1);
            },
        });

        // Complementary products
        var complementaryProductsEl = document.querySelector(
            "[data-complementary-products]"
        );
        if (complementaryProductsEl) {
            var sectionEl = complementaryProductsEl.closest(".product_section");
            var _JSON$parse = JSON.parse(
                    document.querySelector("[data-complementary-products-data]")
                        .textContent
                ),
                sectionId = _JSON$parse.sectionId,
                productId = _JSON$parse.productId,
                productRecommendationLimit =
                    _JSON$parse.productRecommendationLimit;
            this.complementaryProductRecommendations =
                new ComplementaryProducts({
                    sectionEl: sectionEl,
                    sectionId: sectionId,
                    productId: productId,
                    productRecommendationsRoute:
                        window.PXUTheme.routes.product_recommendations_url,
                    includeIndicatorDots: true,
                    limit: productRecommendationLimit,
                    arrowShape:
                        "M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z",
                });
        }

        /*
      If the product recommendations section exists, run the loadProductRecommendations method
      The selectCallback within this method will only affect the products in the product recommendations section
    */
        if ($(".shopify-section--recommended-products").length) {
            window.productPage.loadProductRecommendations();
        }
    },
    runOptionSelector: function runOptionSelector($element) {
        var $defaultSelector = $(
            ".js-product-section [data-product-form]:not(.product-recommendations .js-product-section [data-product-form])"
        );
        if ($element) {
            $defaultSelector = $element.find("[data-product-form]");
        }
        $defaultSelector.each(function (_, options) {
            var $options = $(options);
            var $productDetails = $options.closest(".product__details");

            // Set up variables for price ui and surface pickup
            var priceUIEl;
            var paymentTerms = new window.PaymentTerms($productDetails[0]);

            // If smaller screen size and thumbnail hover enabled
            // use price ui element inside of caption instead
            if (
                window.PXUTheme.media_queries.medium.matches &&
                window.PXUTheme.theme_settings.hover_enabled &&
                window.PXUTheme.theme_settings.quick_shop_enabled &&
                window.PXUTheme.theme_settings.quick_shop_style === "inline"
            ) {
                priceUIEl = $productDetails.find(
                    ".modal_price [data-price-ui], .product-info__caption [data-price-ui]"
                )[0];
            } else {
                priceUIEl = $productDetails.find("[data-price-ui]")[0];
            }
            var priceUIBadgeEl = $productDetails.find(
                "[data-price-ui-badge]"
            )[0];
            var surfacePickUpEl = $productDetails.find(
                "[data-surface-pick-up]"
            )[0];
            var JSONData = $options.data("product");
            var isPriceSavingsEnabled =
                priceUIEl &&
                priceUIEl.closest(['[data-display-savings="true"]']);
            var productTitle = $options.data("product-title");
            var priceUI;
            var priceUIBadge;
            var surfacePickUp;
            var currentVariant;
            if (priceUIEl) {
                priceUI = new window.ShopifyPriceUI.PriceUI(priceUIEl);
            }
            if (priceUIBadgeEl) {
                priceUIBadge = new window.ShopifyPriceUI.PriceUIBadge(
                    priceUIBadgeEl
                );
            }
            if (surfacePickUpEl) {
                surfacePickUp = new window.ShopifySurfacePickUp(
                    surfacePickUpEl
                );
                surfacePickUp.onModalRequest(function (contents) {
                    var surfacePickUpModal = document.querySelector(
                        "[data-surface-pick-up-modal]"
                    );
                    var fragment;
                    if (currentVariant.title && productTitle) {
                        fragment = document.createDocumentFragment();
                        var header = document.createElement("div");
                        var title = document.createElement("h2");
                        header.classList.add("surface-pick-up__modal-header");
                        title.classList.add("surface-pick-up__modal-title");
                        title.innerHTML = productTitle;
                        header.appendChild(title);
                        if (currentVariant.title !== "Default Title") {
                            var subtitle = document.createElement("span");
                            subtitle.classList.add(
                                "surface-pick-up__modal-subtitle"
                            );
                            subtitle.innerHTML = currentVariant.title;
                            header.appendChild(subtitle);
                        }
                        fragment.appendChild(header);
                    }
                    surfacePickUpModal.innerHTML = contents;
                    surfacePickUpModal.insertBefore(
                        fragment,
                        surfacePickUpModal.firstChild
                    );
                    $.fancybox.open(surfacePickUpModal, {
                        hash: false,
                        infobar: false,
                        toolbar: false,
                        loop: true,
                        smallBtn: true,
                        touch: false,
                        video: {
                            autoStart: false,
                        },
                        mobile: {
                            preventCaptionOverlap: false,
                            toolbar: true,
                        },
                    });
                });
            }
            new window.Shopify.OptionSelectors($options.data("select-id"), {
                product: $options.data("product"),
                onVariantSelected: function onVariantSelected(
                    variant,
                    selector
                ) {
                    currentVariant = variant;
                    paymentTerms.update(variant ? variant.id : null);
                    if (priceUI) {
                        priceUI.load(JSONData, {
                            variant: variant,
                            formatter: function formatter(price) {
                                return window.Shopify.formatMoney(
                                    price,
                                    $("body").data("money-format")
                                );
                            },
                            handler: function handler(
                                priceUIFragment,
                                _product,
                                _ref
                            ) {
                                var v = _ref.variant;
                                if (isPriceSavingsEnabled && v) {
                                    if (v.compare_at_price > v.price) {
                                        var span =
                                            document.createElement("span");
                                        span.classList.add("sale", "savings");
                                        var savings =
                                            v.compare_at_price - v.price;
                                        var percentage = Math.round(
                                            (savings / v.compare_at_price) * 100
                                        );
                                        span.innerHTML = ""
                                            .concat(
                                                window.PXUTheme.translation
                                                    .savings_text,
                                                " "
                                            )
                                            .concat(
                                                percentage,
                                                '% (<span class="money">'
                                            )
                                            .concat(
                                                window.Shopify.formatMoney(
                                                    v.compare_at_price -
                                                        v.price,
                                                    $("body").data(
                                                        "money-format"
                                                    )
                                                ),
                                                "</span>)"
                                            );
                                        priceUIFragment.appendChild(span);
                                    }
                                }
                                if (v && v.available) {
                                    if (v.price === 0) {
                                        var fragment =
                                            document.createDocumentFragment();
                                        var _span =
                                            document.createElement("span");
                                        _span.classList.add("free-price-text");
                                        if (
                                            window.PXUTheme.theme_settings
                                                .free_text !== ""
                                        ) {
                                            _span.innerHTML =
                                                window.PXUTheme.theme_settings.free_text;
                                        } else {
                                            _span.innerHTML =
                                                '<span class="money">'.concat(
                                                    window.Shopify.formatMoney(
                                                        v.price,
                                                        $("body").data(
                                                            "money-format"
                                                        )
                                                    ),
                                                    "</span>"
                                                );
                                        }
                                        fragment.appendChild(_span);
                                        return fragment;
                                    }
                                    return priceUIFragment;
                                }
                                if (
                                    !window.PXUTheme.theme_settings
                                        .display_sold_out_price
                                ) {
                                    var _fragment =
                                        document.createDocumentFragment();
                                    var soldOutText =
                                        document.createElement("span");
                                    soldOutText.classList.add("sold_out");
                                    soldOutText.innerHTML = v
                                        ? window.PXUTheme.translation
                                              .sold_out_text
                                        : window.PXUTheme.translation
                                              .unavailable_text;
                                    _fragment.appendChild(soldOutText);
                                    return _fragment;
                                }

                                // Displays sold out text beside price
                                if (
                                    window.PXUTheme.theme_settings
                                        .display_sold_out_price
                                ) {
                                    var _span2 = document.createElement("span");
                                    _span2.classList.add("sold_out");
                                    _span2.innerHTML = v
                                        ? window.PXUTheme.translation
                                              .sold_out_text
                                        : window.PXUTheme.translation
                                              .unavailable_text;
                                    priceUIFragment.appendChild(_span2);
                                }
                                return priceUIFragment;
                            },
                        });
                        if (
                            window.PXUTheme.theme_settings
                                .display_sold_out_price &&
                            variant &&
                            variant.price === 0 &&
                            !variant.available
                        ) {
                            var priceElement =
                                priceUIEl.querySelector("[data-price]");
                            if (!priceElement) {
                                return;
                            }
                            if (
                                window.PXUTheme.theme_settings.free_text !== ""
                            ) {
                                var span = document.createElement("span");
                                span.classList.add("free-price-text");
                                span.innerHTML =
                                    window.PXUTheme.theme_settings.free_text;
                                priceElement.innerHTML = "";
                                priceElement.appendChild(span);
                            } else if (
                                window.PXUTheme.theme_settings.free_text === ""
                            ) {
                                priceElement.classList.add("price--sale");
                                return;
                            }
                        }
                    }
                    if (priceUIBadge) {
                        priceUIBadge.load(JSONData, {
                            variant: variant,
                            style: "default",
                            formatter: function formatter(price) {
                                return window.Shopify.formatMoney(
                                    price,
                                    $("body").data("money-format")
                                );
                            },
                            handler: function handler(
                                priceUIFragment,
                                _product,
                                _ref2
                            ) {
                                var v = _ref2.variant;
                                if (v && v.available) {
                                    if (
                                        !v.compare_at_price ||
                                        v.compare_at_price <= v.price
                                    ) {
                                        return document.createDocumentFragment();
                                    }
                                    return priceUIFragment;
                                }
                                if ((v && !v.available) || !v) {
                                    var fragment =
                                        document.createDocumentFragment();
                                    var text;
                                    var sticker = document.createElement("div");
                                    sticker.classList.add(
                                        "price-ui-badge__sticker"
                                    );
                                    var stickerText =
                                        document.createElement("span");
                                    stickerText.classList.add(
                                        "price-ui-badge__sticker-text"
                                    );
                                    stickerText.setAttribute("data-badge", "");
                                    if (v && !v.available) {
                                        sticker.classList.add(
                                            "price-ui-badge__sticker--sold-out"
                                        );
                                        text =
                                            window.PXUTheme.translation
                                                .sold_out_text;
                                    }
                                    if (!v) {
                                        sticker.classList.add(
                                            "price-ui-badge__sticker--unavailable"
                                        );
                                        text =
                                            window.PXUTheme.translation
                                                .unavailable_text;
                                    }
                                    stickerText.innerHTML = text;
                                    sticker.appendChild(stickerText);
                                    fragment.appendChild(sticker);
                                    return fragment;
                                }
                                return priceUIFragment;
                            },
                        });
                    }

                    // Avoid loading surface pickup for the inline quick shop
                    if (
                        surfacePickUp &&
                        !$options
                            .closest(".js-product-section")
                            .hasClass("inline-quickshop")
                    ) {
                        surfacePickUp.load(variant ? variant.id : null);
                    }
                    window.selectCallback(variant, selector, $element);
                },
                enableHistoryState: $options.data("enable-state"),
            });
        });
    },
    enableGallery: function enableGallery(selector) {
        // Variables
        var $productGallery = $(selector);
        var $slides = $productGallery.find(".gallery-cell");
        var $thumbnailProductGallery = $productGallery
            .closest(".js-product-section")
            .find(".product_gallery_nav");
        var $thumbnails = $thumbnailProductGallery.find(".gallery-cell");
        var zoom = $productGallery.data("zoom");
        var productLightbox = $productGallery.data("product-lightbox");
        var thumbnailsEnabled = $productGallery.data("thumbnails-enabled");
        var thumbnailsSliderEnabled = $productGallery.data(
            "thumbnails-slider-enabled"
        );
        var thumbnailsPosition = $productGallery.data("thumbnails-position");
        var thumbnailsArrows = $productGallery.data("gallery-arrows-enabled");
        var slideshowSpeed = $productGallery.data("slideshow-speed");

        // If zoom enabled
        if (zoom === true) {
            if (
                window.is_touch_device() &&
                window.PXUTheme.media_queries.medium.matches
            ) {
                // Lightbox has a built-in zoom feature, so check if lightbox is disabled
                if (productLightbox === "false") {
                    document.addEventListener(
                        "lazybeforeunveil",
                        window.imageFunctions.zoom
                    );
                }
            } else {
                document.addEventListener(
                    "lazybeforeunveil",
                    window.imageFunctions.zoom
                );
            }
        }
        $productGallery.on("ready.flickity", function () {
            $slides.each(function (index, slide) {
                // Determine media type
                var mediaType =
                    $(slide).data("media-type") ||
                    $(slide).find("[data-media-type]").data("media-type");
                var videoID;
                switch (mediaType) {
                    case "external_video":
                        videoID = $(slide)
                            .find("[data-plyr-video-id]")
                            .data("plyr-video-id");
                        if (window.videoPlayers) {
                            window.videoPlayers.forEach(function (player) {
                                var currentPlayer = player;
                                if (
                                    player.id === videoID ||
                                    player.media.id === videoID
                                ) {
                                    if (!$(slide).hasClass("is-selected")) {
                                        currentPlayer.keyboard = {
                                            focused: false,
                                            global: false,
                                        };
                                    }
                                }
                            });
                        }
                        break;
                    case "video":
                        videoID = $(slide)
                            .find("[data-plyr-video-id]")
                            .data("plyr-video-id");
                        if (window.videoPlayers) {
                            window.videoPlayers.forEach(function (player) {
                                var currentPlayer = player;
                                if (
                                    player.id === videoID ||
                                    player.media.id === videoID
                                ) {
                                    if (!$(slide).hasClass("is-selected")) {
                                        currentPlayer.keyboard = {
                                            focused: false,
                                            global: false,
                                        };
                                    }
                                }
                            });
                        }
                        break;
                    case "model":
                        if ($(slide).hasClass("is-selected")) {
                            // When active slide
                            if (
                                mediaType === "model" &&
                                window.isScreenSizeLarge()
                            ) {
                                $(slide).on("mouseenter", function () {
                                    $productGallery.flickity("unbindDrag");
                                });
                                $(slide).on("mouseleave", function () {
                                    $productGallery.flickity("bindDrag");
                                });
                            }
                        }
                        break;
                    default:
                        break;
                }
            });

            // Video looping
            var loopingEnabled = $productGallery.data("video-loop");
            $.each(window.videoPlayers, function (index, player) {
                var videoPlayer = player;
                videoPlayer.loop = loopingEnabled;
            });
        });
        $productGallery.on("change.flickity", function () {
            $slides.each(function (index, slide) {
                // Determine media type of current slide
                var mediaType =
                    $(slide).data("media-type") ||
                    $(slide).find("[data-media-type]").data("media-type");
                if ($(slide).hasClass("is-selected")) {
                    // When active slide
                    switch (mediaType) {
                        case "model":
                            /* On slide change, if active slide contains 3d model
                             * If on desktop, on hover, unbind flickity, after hover bind flickity
                             * On model play event, unbind flickity to ensure model can be interacted with
                             * On model pause event, bind flickity so that slide can be swiped
                             * Pause all model slides when hidden
                             */

                            if (window.isScreenSizeLarge()) {
                                // On mouseenter event, unbind flickity
                                $(slide).on("mouseenter", function () {
                                    $productGallery.flickity("unbindDrag");
                                });

                                // On mouseleave event, bind flickity
                                $(slide).on("mouseleave", function () {
                                    $productGallery.flickity("bindDrag");
                                });
                            }

                            // Listen for model pause/play events
                            $(slide)
                                .find("model-viewer")
                                .on(
                                    "shopify_model_viewer_ui_toggle_play",
                                    function () {
                                        $productGallery.flickity("unbindDrag");
                                    }
                                );
                            $(slide)
                                .find("model-viewer")
                                .on(
                                    "shopify_model_viewer_ui_toggle_pause",
                                    function () {
                                        $productGallery.flickity("bindDrag");
                                    }
                                );
                            break;
                        default:
                            $productGallery.flickity("bindDrag");
                            break;
                    }
                } else {
                    // When inactive slide
                    switch (mediaType) {
                        case "external_video":
                            // Youtube video pausing
                            $.each(
                                window.videoPlayers,
                                function (_index, player) {
                                    player.pause();
                                }
                            );
                            break;
                        case "video":
                            // HTML5 video pausing
                            $.each(
                                window.videoPlayers,
                                function (_index, player) {
                                    player.pause();
                                }
                            );
                            break;
                        default:
                            break;
                    }
                }
            });

            // Restore 3d model icons
            window.productMedia.showModelIcon($productGallery);
        });
        $productGallery.flickity({
            wrapAround: true,
            adaptiveHeight: true,
            dragThreshold: 10,
            imagesLoaded: true,
            pageDots: false,
            prevNextButtons:
                $productGallery.data("media-count") > 1 || $slides.length > 1,
            autoPlay: slideshowSpeed * 1000,
            watchCSS: false,
        });

        // Adjust arrows height if controls are hidden/shown
        $.each(window.videoPlayers, function (index, player) {
            // When controls are hidden, height should be auto
            player.on("controlshidden", function () {
                $productGallery
                    .find(".flickity-prev-next-button")
                    .css("height", "auto");
            });
            // When controls are shown, height should account for controls bar
            player.on("controlsshown", function () {
                $productGallery
                    .find(".flickity-prev-next-button")
                    .css("height", "calc(100% - 64px)");
            });
        });
        function autoplayVideo(videoID, $slide) {
            // Compare id to player object and only play that video
            $.each(window.videoPlayers, function (index, player) {
                if (
                    parseInt(player.media.dataset.plyrVideoId, 10) === videoID
                ) {
                    player.play();

                    // On fullscreen toggle, focus back on the slide itself
                    player.on("exitfullscreen", function () {
                        $slide
                            .closest(".product-gallery")
                            .find(".product-gallery__thumbnails")
                            .focus();
                    });
                }
            });
        }
        function autoplayYoutubeVideo(iframeID, $slide) {
            // compare id to player object and only play that video
            $.each(window.videoPlayers, function (index, player) {
                if (player.playing) {
                    player.pause();
                }
                if (player.media.id === iframeID) {
                    player.play();

                    // On fullscreen toggle, focus back on the slide itself
                    player.on("exitfullscreen", function () {
                        $slide
                            .closest(".product-gallery")
                            .find(".product-gallery__thumbnails")
                            .focus();
                    });
                }
            });
        }
        function checkForVideos() {
            $slides.each(function (index, slide) {
                // Variables
                var $slide = $(slide);
                var mediaType =
                    $slide.data("media-type") ||
                    $slide.find("[data-media-type]").data("media-type");
                var videoID = $slide.find("video").data("plyr-video-id");
                var $iframeVideo = $slide.find("iframe");
                var iframeID = $iframeVideo.attr("id");
                if ($slide.hasClass("is-selected")) {
                    if (mediaType === "video") {
                        videoID = $slide.find("video").data("plyr-video-id");
                        if (videoID) {
                            autoplayVideo(videoID, $slide);
                        }
                    } else if (mediaType === "external_video" && iframeID) {
                        autoplayYoutubeVideo(iframeID, $slide);
                    }
                }
            });
        }

        // Checks for videos and plays them if they are the featured media
        // Autoplay logic only happens on desktop, autoplay set to off for mobile
        var $sliderArrows = $productGallery.find(".flickity-prev-next-button");
        if (($sliderArrows || $thumbnails) && window.isScreenSizeLarge()) {
            $sliderArrows.on("click", function () {
                var pId = $productGallery.data("product-id");
                $productGallery.on("settle.flickity", function () {
                    // Find out media type of featured media slide
                    var $selectedSlide = $productGallery.find(
                        ".gallery-cell.is-selected"
                    );
                    var mediaType =
                        $selectedSlide.data("media-type") ||
                        $selectedSlide
                            .find("[data-media-type]")
                            .data("media-type");

                    // Run video autoplay logic if featured media is a video
                    if (
                        mediaType === "video" ||
                        mediaType === "external_video"
                    ) {
                        checkForVideos();
                    }

                    // Autoplay model if featured media is a model
                    if (mediaType === "model") {
                        // If model container has class is-selected then play the model
                        var sortedModels = [];
                        $.each(window.productMedia.models, function (model) {
                            if (
                                $(model.container)
                                    .closest(".gallery-cell")
                                    .data("product-id") === pId
                            ) {
                                sortedModels.push(model);
                            }
                        });
                        $.each(sortedModels, function (model) {
                            var $slide = $(model.container).closest(
                                ".gallery-cell"
                            );
                            if ($slide.hasClass("is-selected")) {
                                model.play();
                            }
                        });
                    }
                    $productGallery.off("settle.flickity");
                });
                return false;
            });
            $thumbnails.on("click", function (event) {
                var index = $(event.currentTarget).index();
                var pId = $productGallery.data("product-id");
                $productGallery.flickity("select", index);
                $productGallery.on("settle.flickity", function () {
                    // Find out media type of featured media slide
                    var $selectedSlide = $productGallery.find(
                        ".gallery-cell.is-selected"
                    );
                    var mediaType =
                        $selectedSlide.data("media-type") ||
                        $selectedSlide
                            .find("[data-media-type]")
                            .data("media-type");

                    // Run video autoplay logic if featured media is a video
                    if (
                        mediaType === "video" ||
                        mediaType === "external_video"
                    ) {
                        checkForVideos();
                    }

                    // Autoplay model if featured media is a model
                    if (mediaType === "model") {
                        // If model container has class is-selected then play the model
                        var sortedModels = [];
                        $.each(
                            window.productMedia.models,
                            function (_index, model) {
                                if (
                                    $(model.container)
                                        .closest(".gallery-cell")
                                        .data("product-id") === pId
                                ) {
                                    sortedModels.push(model);
                                }
                            }
                        );
                        $.each(sortedModels, function (_index, model) {
                            var $slide = $(model.container).closest(
                                ".gallery-cell"
                            );
                            if ($slide.hasClass("is-selected")) {
                                model.play();
                            }
                        });
                    }
                    $productGallery.off("settle.flickity");
                });
                return false;
            });
            $thumbnails.keypress(function (event) {
                var index = $(event.currentTarget).index();
                var pId = $productGallery.data("product-id");
                if (event.which === 13) {
                    $productGallery.flickity("select", index);
                    var $selectedSlide = $productGallery.find(
                        ".gallery-cell.is-selected"
                    );
                    $productGallery.on("settle.flickity", function () {
                        $selectedSlide
                            .find("[data-youtube-video]")
                            .attr("tabindex", "0");
                        $selectedSlide.find("model-viewer, .plyr, a").focus();
                        $productGallery.off("settle.flickity");
                    });

                    // Find out media type of featured media slide
                    var mediaType =
                        $selectedSlide.data("media-type") ||
                        $selectedSlide
                            .find("[data-media-type]")
                            .data("media-type");

                    // Run video autoplay logic if featured media is a video
                    if (
                        mediaType === "video" ||
                        mediaType === "external_video"
                    ) {
                        checkForVideos();
                    }

                    // Autoplay model if featured media is a model
                    if (mediaType === "model") {
                        // If model container has class is-selected then play the model
                        var sortedModels = [];
                        $.each(window.productMedia.models, function (model) {
                            if (
                                $(model.container)
                                    .closest(".gallery-cell")
                                    .data("product-id") === pId
                            ) {
                                sortedModels.push(model);
                            }
                        });
                        $.each(sortedModels, function (model) {
                            var $slide = $(model.container).closest(
                                ".gallery-cell"
                            );
                            if ($slide.hasClass("is-selected")) {
                                model.play();
                            }
                        });
                    }
                    return false;
                }
                return undefined;
            });
        }

        // Thumbnail gallery logic begins
        if (
            thumbnailsEnabled === true &&
            thumbnailsSliderEnabled === true &&
            $slides.length > 1
        ) {
            // If desktop determine which slider we build
            if (window.PXUTheme.media_queries.large.matches) {
                // If thumbnail position is left/right then vertical slider gets enabled
                if (
                    thumbnailsPosition === "left" ||
                    thumbnailsPosition === "right"
                ) {
                    $thumbnailProductGallery.css(
                        "max-height",
                        $productGallery
                            .closest(".product-gallery")
                            .outerHeight()
                    );
                    $thumbnailProductGallery.addClass(
                        "vertical-slider-enabled"
                    );
                    $thumbnails.on("click", function (event) {
                        var index = $(event.currentTarget).index();
                        $productGallery.flickity("select", index);
                    });
                    var navCellHeight = $thumbnails.height();
                    var navHeight = $thumbnailProductGallery.height();
                    $productGallery.on("select.flickity", function () {
                        // set selected nav cell
                        var flkty = $productGallery.data("flickity");
                        $thumbnailProductGallery
                            .find(".is-nav-selected")
                            .removeClass("is-nav-selected");
                        var $selected = $thumbnails
                            .eq(flkty.selectedIndex)
                            .addClass("is-nav-selected");

                        // scroll nav
                        var scrollY =
                            $selected.position().top +
                            $thumbnailProductGallery.scrollTop() -
                            (navHeight + navCellHeight) / 2;
                        $thumbnailProductGallery.animate({
                            scrollTop: scrollY,
                        });
                    });
                } else {
                    $thumbnailProductGallery.flickity({
                        cellAlign: "center",
                        contain: true,
                        groupCells: "80%",
                        imagesLoaded: true,
                        pageDots: false,
                        prevNextButtons:
                            $thumbnails.length > 5 ? thumbnailsArrows : false,
                        asNavFor: $productGallery[0],
                    });
                    $thumbnailProductGallery.on("settle.flickity", function () {
                        $thumbnailProductGallery.flickity("resize");
                    });
                    $(window).on("load", function () {
                        $thumbnailProductGallery.flickity("resize");
                    });

                    // Once thumbnail is focused, move carousel to that cell
                    $.each($thumbnails, function (index, thumbnail) {
                        var $thumbnail = $(thumbnail);
                        if ($thumbnail.hasClass("is-selected")) {
                            $thumbnail.on("focus", function () {
                                $thumbnailProductGallery.flickity(
                                    "selectCell",
                                    index
                                );
                            });
                        }
                    });
                }
            } else {
                // If not on desktop, create standard thumbnail slider
                $thumbnailProductGallery.flickity({
                    cellAlign: "center",
                    contain: true,
                    groupCells: "80%",
                    imagesLoaded: true,
                    pageDots: false,
                    prevNextButtons:
                        $thumbnails.length > 5 ? thumbnailsArrows : false,
                    asNavFor: $productGallery[0],
                });
            }
        } else if (thumbnailsEnabled === true) {
            // If thumbnail slider is disabled, ensure thumbnails can still navigate product images
            $thumbnailProductGallery
                .find(".product-gallery__thumbnail")
                .on("click", function () {
                    var index = $(this).index();
                    $productGallery.flickity("selectCell", index);
                });
        }
        $(window).on("load", function () {
            $productGallery.flickity().flickity("resize");
        });
        $productGallery.on("settle.flickity", function () {
            $productGallery.flickity().flickity("resize");
        });
    },
    loadProductRecommendations: function loadProductRecommendations() {
        var $productRecommendations = $("[data-product-recommendations]");
        var $productRecommendationsSection = $(
            ".shopify-section--recommended-products"
        );
        var sectionID = $productRecommendations.data("section-id");
        var productID = $productRecommendations.data("product-id");
        var limit = $productRecommendations.data("limit");
        var recommendationsURL = $productRecommendations.data(
            "recommendations-url"
        );
        var sectionEnabled = $productRecommendationsSection
            .find($productRecommendations)
            .data("enabled");
        var $recommendedProductSlider = $(".js-recommended-products-slider");
        function loadDynamicProducts() {
            // Build request URL
            var requestUrl = ""
                .concat(recommendationsURL, "?section_id=")
                .concat(sectionID, "&limit=")
                .concat(limit, "&product_id=")
                .concat(productID);

            // Make ajax call to request information for window.Shopify's recommended products
            $.ajax({
                type: "GET",
                url: requestUrl,
                success: function success(data) {
                    if (!sectionEnabled) {
                        return;
                    }
                    var $recommendedProductsElement = $(data)
                        .find(".product-recommendations")
                        .html();

                    // Insert product list into the product recommendations container
                    $productRecommendations.html($recommendedProductsElement);

                    // Initialize product slider if it exists on page
                    if ($recommendedProductSlider.length) {
                        window.productPage.recommendedProductsSlider();
                    } else {
                        // Call enable gallery function for product galleries
                        $(
                            "[data-product-recommendations] [data-product-gallery]"
                        ).each(function (_, gallery) {
                            var $productGallery = $(gallery);
                            window.productPage.enableGallery($productGallery);
                        });
                    }

                    // Converting the currencies
                    if (window.PXUTheme.currency.show_multiple_currencies) {
                        window.currencyConverter.convertCurrencies();
                    }

                    // Run option selectors
                    window.productPage.runOptionSelector(
                        $productRecommendationsSection
                    );

                    // Initialize shopify payment buttons
                    if (window.Shopify.PaymentButton) {
                        window.Shopify.PaymentButton.init();
                    }

                    // Hide <noscript> elements
                    window.hideNoScript();

                    // Initialize video players
                    window.videoFeature.setupRecommendedVideoPlayer();

                    // Initialize swatch toggler
                    $(".swatch_options label").on("click", function () {
                        window.quickShop.toggleSwatchImages($(this));
                    });

                    // Initialize the show secondary media on hover feature
                    if (
                        window.PXUTheme.theme_settings
                            .collection_secondary_image
                    ) {
                        window.imageFunctions.showSecondaryImage();
                    }
                },
            });
        }
        if (!sectionEnabled) {
            return;
        }

        // If meta collection, no need to run API request
        var metaCollection = $productRecommendations.hasClass(
            "meta-related-recommended-collection"
        );
        if (metaCollection) {
            // Takes care of moving content from Shopify section into block container

            // Initialize product slider if it exists on page
            if ($recommendedProductSlider.length) {
                window.productPage.recommendedProductsSlider();
            } else {
                // Call enable gallery function for product galleries
                $(".product-recommendations [data-product-gallery]").each(
                    function () {
                        var $productGallery = $(this);
                        window.productPage.enableGallery($productGallery);
                    }
                );
            }

            // Run option selectors
            window.productPage.runOptionSelector(
                $productRecommendationsSection
            );
        } else {
            loadDynamicProducts();
        }
    },
    productSwatches: function productSwatches() {
        // Swatches linked with selected options
        if (window.PXUTheme.theme_settings.product_form_style === "radio") {
            if ($(".js-product-section").length) {
                var $productForms = $(".js-product-section").find(
                    ".product_form"
                );
                $productForms.addClass("is-visible");

                // Loop through each product and set the initial option value state

                $productForms.each(function (_, productForm) {
                    var $productForm = $(productForm);
                    var JSONData = $productForm.data("product");
                    var productID = $productForm.data("product-id");
                    var productSection = ".product-".concat(
                        productID,
                        " .js-product-section"
                    );
                    var swatchOptions = $productForm.find(
                        ".swatch_options .swatch"
                    );
                    if (swatchOptions.length > 1) {
                        window.Shopify.linkOptionSelectors(
                            JSONData,
                            productSection
                        );
                    }
                });
            }

            // Add click event when there is more than one product on the page (eg. Collection in Detail)
            if ($(".js-product-section").length > 1) {
                $("body").on(
                    "click",
                    ".swatch-element",
                    function (swatchElement) {
                        var $swatchElement = $(swatchElement.currentTarget);
                        var swatchValue = $swatchElement
                            .data("value")
                            .toString();
                        $swatchElement
                            .siblings(
                                'input[value="'.concat(
                                    swatchValue.replace(/"/g, '\\"'),
                                    '"]'
                                )
                            )
                            .prop("checked", true)
                            .trigger("change");
                        var JSONData = $swatchElement
                            .parents(".product_form")
                            .data("product");
                        var productID = $swatchElement
                            .parents(".product_form")
                            .data("product-id");
                        var productSection = ".product-".concat(
                            productID,
                            " .js-product-section"
                        );
                        var swatchOptions = $swatchElement
                            .parents(".product_form")
                            .find(".swatch_options .swatch");
                        if (swatchOptions.length > 1) {
                            window.Shopify.linkOptionSelectors(
                                JSONData,
                                productSection
                            );
                        }
                    }
                );
            }
        }
    },
    recommendedProductsSlider: function recommendedProductsSlider() {
        $(".product-recommendations .products-slider").each(function (
            _,
            productSlider
        ) {
            var $productSlider = $(productSlider);
            var productsPerSlide = $productSlider.data("products-per-slide");
            var productsLimit = $productSlider.data("products-limit");
            var productsAvailable = $productSlider.data("products-available");
            var cellAlign;
            var draggable;
            var prevNext;
            var wrapAround;
            var initialIndex;
            var lessSlidesThanProducts = productsAvailable > productsPerSlide;
            var limitGreaterThanSlide = productsLimit > productsPerSlide;
            var evenSlide = productsPerSlide % 2 === 0;
            if (evenSlide && lessSlidesThanProducts && limitGreaterThanSlide) {
                cellAlign = "left";
            } else {
                cellAlign = "center";
            }
            if (lessSlidesThanProducts && limitGreaterThanSlide) {
                draggable = true;
                prevNext = true;
                wrapAround = true;
            } else {
                draggable = false;
                prevNext = false;
                wrapAround = false;
            }
            if (evenSlide && lessSlidesThanProducts && limitGreaterThanSlide) {
                initialIndex = 0;
            } else if (productsPerSlide === "3" && productsAvailable) {
                initialIndex = 1;
            } else if (productsPerSlide === "5" && productsAvailable) {
                initialIndex = 2;
            } else if (productsPerSlide === "7" && productsAvailable) {
                initialIndex = 3;
            }
            if (window.PXUTheme.media_queries.medium.matches) {
                cellAlign = "center";
                draggable = true;
                prevNext = true;
                wrapAround = true;
                initialIndex = 1;
                $productSlider
                    .parents(".even-num-slides")
                    .removeClass("even-num-slides");
            }
            $productSlider.flickity({
                lazyLoad: 2,
                imagesLoaded: true,
                draggable: draggable,
                cellAlign: cellAlign,
                prevNextButtons: prevNext,
                wrapAround: wrapAround,
                contain: true,
                freeScroll: true,
                initialIndex: initialIndex,
            });
        });
    },
    initializeQuantityBox: function initializeQuantityBox() {
        $("body").on("click", ".js-change-quantity", function (e) {
            var $this = $(e.currentTarget);
            var $input = $this.siblings("input");
            var val = parseInt($input.val(), 10);
            var valMax = 100000000000000000000000000000;
            var valMin = $input.attr("min") || 0;
            if ($input.attr("max") != null) {
                valMax = $input.attr("max");
            }
            if (isNaN(val) || val < valMin) {
                $input.val(valMin);
            }
            if (val > valMax) {
                $input.val(valMax);
            }
            if ($this.data("func") === "plus") {
                if (val < valMax) $input.val(val + 1);
            } else {
                if (val > valMin) $input.val(val - 1);
                if ($this.parents(".cart_item").length) {
                    if (val - 1 === 0) {
                        $this
                            .closest(".cart_item")
                            .addClass("animated fadeOutUp");
                    }
                }
            }
            $input.trigger("change");
        });
    },
    unload: function unload($target) {
        var $slider = $target.find(".products-slider");
        $slider.flickity("destroy");
        $("body").off("click", ".js-change-quantity");
    },
};

/*============================================================================
  Header
==============================================================================*/
var HeaderFader = /*#__PURE__*/ (function () {
    function HeaderFader() {
        _classCallCheck(this, HeaderFader);
        this.el = document.querySelector("[data-desktop-header]");
        if (!this.el) return;
        this.openers = new Set();
        this.fadeClass = "feature_image";
        if (this.el.classList.contains("feature_image")) {
            this.shouldFade = this.el.classList.contains("feature_image");
        }
    }
    _createClass(HeaderFader, [
        {
            key: "updateShouldFade",
            value: function updateShouldFade(shouldFade) {
                if (!this.el) return;

                // No menus are open
                if (!this.openers.size) {
                    this.shouldFade = shouldFade;
                    return;
                }

                // 1+ menus are open
                if (shouldFade) {
                    this._fade();
                    this.shouldFade = shouldFade;
                } else {
                    if (this.shouldFade) {
                        this.openers.clear();
                        this._clear();
                    }
                    this.shouldFade = shouldFade;
                }
            },
        },
        {
            key: "fade",
            value: function fade(requestor) {
                if (!this.el) return;
                if (!this.shouldFade) return;
                if (this.openers.has(requestor)) return;
                this.openers.add(requestor);
                this._fade();
            },
        },
        {
            key: "clear",
            value: function clear(requestor) {
                if (!this.el) return;
                if (!this.shouldFade) return;
                this.openers["delete"](requestor);
                if (this.openers.size) return;
                this._clear();
            },
        },
        {
            key: "_fade",
            value: function _fade() {
                this.el.classList.remove(this.fadeClass);
            },
        },
        {
            key: "_clear",
            value: function _clear() {
                this.el.classList.add(this.fadeClass);
            },
        },
    ]);
    return HeaderFader;
})();
/**
 * @class NavigationDesktopParent
 * @classdesc NavigationDesktopParent controls the functionality of tier 2 menus
 */
var NavigationDesktopParent = /*#__PURE__*/ (function () {
    function NavigationDesktopParent(options) {
        var _this = this;
        _classCallCheck(this, NavigationDesktopParent);
        this.menuItem = options.menuItem;
        this.detailsItem = options.menuItem.querySelector(
            "[data-nav-desktop-details]"
        );
        this.parentMenu = options.parentMenu;
        this._locked =
            options.locked ||
            function () {
                return false;
            };
        this.menuLink = this.detailsItem.querySelector(
            "[data-nav-desktop-link]"
        );
        this.submenuEl = this.menuItem.querySelector(
            "[data-nav-desktop-submenu]"
        );
        this.isWideNav = "navDesktopFullWidthMenu" in this.submenuEl.dataset;
        this.openOnClick = this.menuItem.closest(
            "[data-show-dropdown-on-click]"
        );
        this._isOpen = false;
        this.submenu = null;
        this.events = new window.EventHandler();
        this._open = this._open.bind(this);
        this._close = this._close.bind(this);
        this.close = this.close.bind(this);

        // When a user hits the escape key all of the menus should close and the keyboard focus should return
        // to the parent link. This will bubble up to the top parent menu.
        this.closeEsc = function (e) {
            if (e.key === "Escape") {
                _this.menuLink.focus();
                _this._close();
            }
        };

        // When the mouse leaves the open menu, we don't want to close it right away. Setting a delay on close
        // allows situations where you might go to another parent menu but your mouse would drag slightly outside
        // of the open menu, causing you to have to go back and open the menu again. This improves accessibility
        // as well as general usability.
        this.closeTimer = null;
        this.mouseover = function () {
            clearTimeout(_this.closeTimer);
            _this._open();
        };
        this.mouseout = function () {
            _this.closeTimer = setTimeout(_this.close, 400);
        };
        this.click = function (e) {
            e.stopPropagation();
            // If the menu is already open, we want to continue to the link in the <a> tag.
            // For mouse hover, this is pretty straightforward, but with keyboard and touch navigation
            // you will have to touch or trigger that link a second time. This is maybe not the best for
            // accessibility, but it's a good compromise for now.

            var clickedParent = e.target.closest("[data-nav-desktop-link]");
            if (clickedParent && "href" in clickedParent.dataset) {
                // We only prevent the click through if the menu wasn't already open.
                e.preventDefault();
                if (_this._isOpen) {
                    window.location = clickedParent.dataset.href;
                    return;
                }
            }

            // If the submenu isn't open, open it
            _this._open();
        };

        // During keyboard navigation, when you focus onto the parent menuItem, this will close the other
        // menu items that were previously open. This usually happens when you were navigating within
        // a submenu and then tab out of it to the next menu item at a lower tier.
        this.focusin = function (e) {
            e.stopPropagation();
            _this.parentMenu.closeSiblings(_this);
        };

        // Set up animation event
        this.animation = window.animations.transition({
            el: this.submenuEl,
            state: "closed",
        });
        if (!this.openOnClick) {
            this.events.register(this.menuItem, "mouseover", function () {
                return _this.mouseover();
            });
            this.events.register(this.menuItem, "mouseout", function () {
                return _this.mouseout();
            });
        }
        this.events.register(this.menuItem, "click", function (e) {
            return _this.click(e);
        });
        this.events.register(this.menuItem, "touchend", function (e) {
            return _this.click(e);
        });
        this.events.register(this.menuItem, "focusin", function (e) {
            return _this.focusin(e);
        });

        // If the user clicks, taps, or their keyboard focus reaches outside of the menu
        // we should close this menu.
        this.events.register(document.body, "click", function () {
            return _this._close();
        });
        this.events.register(document.body, "focusin", function () {
            return _this._close();
        });
    }

    /**
     * Close the dropdown menu immediately
     *
     */
    _createClass(NavigationDesktopParent, [
        {
            key: "forceClose",
            value: function forceClose() {
                this._close();
            },

            /**
             * Close the dropdown menu
             *
             */
        },
        {
            key: "close",
            value: function close() {
                this._close();
            },

            /**
             * Open the dropdown menu immediately
             */
        },
        {
            key: "forceOpen",
            value: function forceOpen() {
                this._open(true);
            },

            /**
             * Open the dropdown menu
             */
        },
        {
            key: "open",
            value: function open() {
                this._open();
            },

            /**
             * Check to see if dropdown is offscreen and apply a class so it can be styled differently.
             */
        },
        {
            key: "_setAlternateDrop",
            value: function _setAlternateDrop() {
                if (this.isWideNav) return;
                var menuBounds = this.submenuEl.getBoundingClientRect();
                if (menuBounds.right > document.documentElement.clientWidth) {
                    this.submenuEl.classList.add("alternate-drop");
                }
                if (menuBounds.left < 0) {
                    this.submenuEl.classList.add("alternate-drop-left");
                }
            },

            /**
             * Remove any class applied to prevent offscreen menus
             */
        },
        {
            key: "_removeAlternateDrop",
            value: function _removeAlternateDrop() {
                this.submenuEl.classList.remove("alternate-drop");
            },

            /**
             * Opens the dropdown menu
             *
             * @private
             */
        },
        {
            key: "_open",
            value: function _open() {
                var _this2 = this;
                var force =
                    arguments.length > 0 && arguments[0] !== undefined
                        ? arguments[0]
                        : false;
                if (this._isOpen || this._locked()) return;
                this._isOpen = true;
                this.parentMenu.closeSiblings(this);
                this.closeEscEvent = this.events.register(
                    window,
                    "keyup",
                    function (e) {
                        return _this2.closeEsc(e);
                    }
                );
                if (!this.submenu) {
                    this.submenu = new NavigationDesktopMenu({
                        navList: this.submenuEl,
                    });
                }
                this._removeAlternateDrop();
                if (this.isWideNav) {
                    window.headerFader.fade(this);
                }
                this.detailsItem.setAttribute("open", "open");
                this.animation
                    .animateTo("open", {
                        onStart: function onStart(_ref3) {
                            var el = _ref3.el;
                            _this2._setAlternateDrop();
                        },
                        force: force,
                    })
                    .then(function (state) {
                        if (state == "open") {
                            _this2.menuLink.setAttribute("aria-expanded", true);
                        }
                    });
            },

            /**
             * Closes the dropdown menu
             *
             * @private
             */
        },
        {
            key: "_close",
            value: function _close() {
                var _this3 = this;
                if (!this._isOpen || this._locked()) return;
                if (this.submenu) {
                    this.submenu.unload();
                    this.submenu = null;
                }
                this._isOpen = false;
                this.events.unregister(this.closeEscEvent);
                if (this.isWideNav) {
                    window.headerFader.clear(this);
                }
                this.animation.animateTo("closed").then(function (state) {
                    if (state == "closed") {
                        _this3._removeAlternateDrop();
                        _this3.menuLink.setAttribute("aria-expanded", false);
                        _this3.detailsItem.removeAttribute("open");
                    }
                });
            },

            /**
             * Unbinds all events
             *
             */
        },
        {
            key: "unload",
            value: function unload() {
                this.forceClose();
                this.events.unregisterAll();
                if (this.closeEscEvent) {
                    this.events.unregister(this.closeEscEvent);
                }
            },
        },
    ]);
    return NavigationDesktopParent;
})();
/**
 * @class NavigationDesktopMenu
 * @classdesc NavigationDesktopMenu controls the overall menu functionality and initializes Tier 2 menus
 */
var NavigationDesktopMenu = /*#__PURE__*/ (function () {
    function NavigationDesktopMenu(options) {
        var _this4 = this;
        _classCallCheck(this, NavigationDesktopMenu);
        this.navList = options.navList;
        this.menuItems = this.navList.children;

        // NavigationDesktopParent for meganav, if any, that is selected for editing in the TE.
        this._selectedBlock = null;
        this.parents = [];
        this.events = new window.EventHandler();
        for (var i = 0; i < this.menuItems.length; i++) {
            var menuItem = this.menuItems[i];
            if ("navDesktopParent" in menuItem.dataset) {
                this.parents.push(
                    new NavigationDesktopParent({
                        menuItem: menuItem,
                        parentMenu: this,
                        locked: function locked() {
                            return _this4._selectedBlock !== null;
                        },
                    })
                );
            } else {
                // If the keyboard navigation moves to another menuItem, we should close any
                // other existing menus that are open.
                this.events.register(menuItem, "focusin", function () {
                    return _this4.closeAllMenus();
                });
            }
        }
    }
    _createClass(NavigationDesktopMenu, [
        {
            key: "onMeganavSelect",
            value: function onMeganavSelect(block) {
                var meganavParent = this.parents.find(function (parent) {
                    return parent.menuItem === block;
                });
                if (!meganavParent) return;
                meganavParent.forceOpen();
                this._selectedBlock = meganavParent;
            },
        },
        {
            key: "onMeganavDeselect",
            value: function onMeganavDeselect() {
                this._selectedBlock = null;
                this.closeAllMenus();
            },

            /**
             * This function will close all menus that are not the current menu.
             * This is mostly used by the HeaderNavParent class.
             *
             * @param { Object } current - The current menuItem
             */
        },
        {
            key: "closeSiblings",
            value: function closeSiblings(current) {
                this.parents.forEach(function (parent) {
                    if (parent !== current) {
                        parent.close();
                    }
                });
            },

            /**
             * This function will close all menus
             *
             */
        },
        {
            key: "closeAllMenus",
            value: function closeAllMenus() {
                this.parents.forEach(function (parent) {
                    return parent.close();
                });
            },

            /**
             * Unbinds all events
             *
             */
        },
        {
            key: "unload",
            value: function unload() {
                this.closeAllMenus();
                this.parents.forEach(function (parent) {
                    parent.unload();
                });
                this.events.unregisterAll();
            },
        },
    ]);
    return NavigationDesktopMenu;
})();
/**
 * @class NavigationDesktop
 * @classdesc Header navigation component is used to display menus on the header and set up their functionality
 *
 */
var NavigationDesktop = /*#__PURE__*/ (function () {
    function NavigationDesktop(el) {
        _classCallCheck(this, NavigationDesktop);
        this.navTier1 = el.querySelector("[data-nav-desktop-tier-1]");
        if (this.navTier1) {
            this.headerNavMenu = new NavigationDesktopMenu({
                navList: this.navTier1,
            });
        }
    }
    _createClass(NavigationDesktop, [
        {
            key: "onMeganavSelect",
            value: function onMeganavSelect(block) {
                if (!this.headerNavMenu) return;
                this.headerNavMenu.onMeganavSelect(block);
            },
        },
        {
            key: "onMeganavDeselect",
            value: function onMeganavDeselect() {
                if (!this.headerNavMenu) return;
                this.headerNavMenu.onMeganavDeselect();
            },
        },
        {
            key: "unload",
            value: function unload() {
                if (!this.headerNavMenu) return;
                this.headerNavMenu.unload();
            },
        },
    ]);
    return NavigationDesktop;
})();
var NavigationDesktopManager = /*#__PURE__*/ (function () {
    function NavigationDesktopManager() {
        _classCallCheck(this, NavigationDesktopManager);
        this.desktopNavs = [];
    }
    _createClass(NavigationDesktopManager, [
        {
            key: "onMeganavSelect",
            value: function onMeganavSelect(block) {
                this.desktopNavs.forEach(function (nav) {
                    return nav.onMeganavSelect(block);
                });
            },
        },
        {
            key: "onMeganavDeselect",
            value: function onMeganavDeselect() {
                this.desktopNavs.forEach(function (nav) {
                    return nav.onMeganavDeselect();
                });
            },
        },
        {
            key: "initAll",
            value: function initAll() {
                this.unload();
                this.desktopNavs = Array.prototype.map.call(
                    document.querySelectorAll("[data-nav-desktop]"),
                    function (navEl) {
                        return new NavigationDesktop(navEl);
                    }
                );
            },
        },
        {
            key: "unload",
            value: function unload() {
                this.desktopNavs.forEach(function (nav) {
                    return nav.unload();
                });
            },
        },
    ]);
    return NavigationDesktopManager;
})();
window.navigationDesktopManager = new NavigationDesktopManager();
var MobileMenuDrawer = /*#__PURE__*/ (function () {
    function MobileMenuDrawer(el) {
        var _this5 = this;
        _classCallCheck(this, MobileMenuDrawer);
        this.el = el;
        if (!this.el) return;
        this.trigger = this.el.querySelector("[data-mobile-menu-trigger]");
        this.icon = this.el.querySelector("[data-mobile-menu-icon]");
        this.animation = window.animations.transition({
            el: this.el.querySelector(["[data-nav]"]),
            state: "closed",
        });
        this.events = new window.EventHandler();
        this.events.register(this.trigger, "click", function (e) {
            e.preventDefault();
            _this5._toggle();
        });
    }
    _createClass(MobileMenuDrawer, [
        {
            key: "_toggle",
            value: function _toggle() {
                if (this.animation.state === "open") {
                    this.close();
                    return;
                }
                this.open();
            },
        },
        {
            key: "open",
            value: function open() {
                if (!this.el) return;
                if (this.animation.state === "open") return;
                this.el.open = true;
                this.icon.classList.add("open");
                document.body.classList.add("is-active");
                this.animation.animateTo("open");
            },
        },
        {
            key: "close",
            value: function close() {
                var _this6 = this;
                if (!this.el) return;
                if (this.animation.state === "closed") return;
                this.icon.classList.remove("open");
                this.animation.animateTo("closed").then(function (state) {
                    if (state === "closed") {
                        _this6.el.open = false;
                        document.body.classList.remove("is-active");
                    }
                });
            },
        },
        {
            key: "unload",
            value: function unload() {
                if (this.events) {
                    this.events.unregisterAll();
                }
            },
        },
    ]);
    return MobileMenuDrawer;
})();
window.header = {
    init: function init() {
        window.headerFader = new HeaderFader();
        window.navigationDesktopManager.initAll();
        window.mobileMenuDrawer = new MobileMenuDrawer(
            document.querySelector("[data-mobile-menu]")
        );
        var closeMiniCart = function closeMiniCart() {
            $("body").removeClass("is-active").removeClass("blocked-scroll");
            $(".dropdown_link").toggleClass("active_link");
            $(".cart-container").removeClass("active_link");
        };
        var openMiniCart = function openMiniCart($cart_container) {
            window.mobileMenuDrawer.close();
            $(".dropdown_link").removeClass("active_link");
            $cart_container.addClass("active_link");
        };
        if ($(".promo-banner").length) {
            var promoBanner = window.Cookies.get("promo-banner");
            if (promoBanner !== "dismiss") {
                $("body").addClass("promo-banner--show");
                $(".promo-banner").on(
                    "click",
                    ".promo-banner__close",
                    function () {
                        $("body").removeClass("promo-banner--show");
                        window.Cookies.set("promo-banner", "dismiss", {
                            expires: 30,
                            path: "",
                            domain: "",
                            sameSite: "None",
                            secure: true,
                        });
                    }
                );
            }
        }

        // Click anywhere outside of dropdown to close
        $("html").on("click", function (event) {
            if (
                !$(event.target).closest(".cart-container").length &&
                $(".cart_content").is(":visible")
            ) {
                closeMiniCart();
            }
        });

        // Close the mini cart when the mobile menu is clicked
        $(".mobile_nav").on("click", function (event) {
            if (
                !$(event.target).closest(".cart-container").length &&
                $(".cart_content").is(":visible")
            ) {
                closeMiniCart();
            }
        });

        //Only apply on larger screen sizes
        if (window.PXUTheme.media_queries.large.matches) {
            if ($(".header").hasClass("header-fixed--true")) {
                //offset scroll position
                $("body").on("click", '.banner a[href^="#"]', function (e) {
                    e.preventDefault();
                    var anchorLink = $(this).attr("href");
                    var headerHeight = $(
                        ".main-nav__wrapper.sticky_nav"
                    ).outerHeight();
                    $("html, body").animate(
                        {
                            scrollTop:
                                $(anchorLink).offset().top - headerHeight,
                        },
                        2000
                    );
                });
                if (!$(".main-nav__wrapper").hasClass("sticky_nav")) {
                    var stickyNavAnimation;
                    window.sticky_nav = new Headhesive(".main-nav__wrapper", {
                        offset: 700,
                        throttle: 300,
                        classes: {
                            clone: "sticky_nav",
                            stick: "sticky_nav--stick",
                            unstick: "sticky_nav--unstick",
                        },
                        onInit: function onInit() {
                            $(".sticky_nav .secondary_logo").css(
                                "display",
                                "none"
                            );
                            $(".sticky_nav .primary_logo").css(
                                "display",
                                "block"
                            );
                            $(".sticky_nav .icon-search").css(
                                "display",
                                "block"
                            );
                            $(".sticky_nav .search__form").css(
                                "display",
                                "none"
                            );
                            $(".sticky_nav .search-link").css(
                                "display",
                                "block"
                            );
                            $(".sticky_nav .main-nav").append(
                                $(".header .cart-container").clone()
                            );
                            window.navigationDesktopManager.initAll();
                            stickyNavAnimation =
                                new window.animations.transition({
                                    el: document.querySelector(".sticky_nav"),
                                    state: "closed",
                                });
                        },
                        onStick: function onStick() {
                            stickyNavAnimation.animateTo("open", {
                                onStart: function onStart() {
                                    var maxHeight = 0;
                                    var $targetHeightElement = $(
                                        ".sticky_nav .main-nav"
                                    );
                                    $targetHeightElement.each(function () {
                                        maxHeight =
                                            maxHeight > $(this).outerHeight()
                                                ? maxHeight
                                                : $(this).outerHeight();
                                    });
                                    $(".sticky_nav .mini_cart").css(
                                        "height",
                                        maxHeight
                                    );
                                    $(".sticky_nav .cart_content").css(
                                        "top",
                                        maxHeight
                                    );
                                    document
                                        .querySelector(".sticky_nav")
                                        .style.setProperty(
                                            "--sticky-header-height",
                                            "".concat(maxHeight, "px")
                                        );
                                },
                            });
                        },
                        onUnstick: function onUnstick() {
                            $(".cart-container").removeClass("active_link");
                            stickyNavAnimation.animateTo("closed", {
                                force: true,
                            });
                        },
                        onDestroy: function onDestroy() {
                            if (stickyNavAnimation) {
                                stickyNavAnimation.unload();
                            }
                        },
                    });
                }
            } else {
                $(".header-fixed--true").removeClass("header-fixed--true");
                if ($(".main-nav__wrapper").length > 1) {
                    $(".main-nav__wrapper").first().remove();
                }
            }
            if ($("img.primary_logo:visible")) {
                $(".logo img", $(".feature_image .header")).attr(
                    "src",
                    $(".logo img").data("src-home")
                );
            } else {
                $(".logo img").attr("src", $(".logo img").data("src"));
            }
            //Mobile menu
        } else {
            if ($("#header").hasClass("mobile_nav-fixed--true")) {
                $("body").addClass("mobile_nav-fixed--true");
                $("body").removeClass("mobile_nav-fixed--false");

                //offset scroll position
                $("body").on("click", '.banner a[href^="#"]', function (e) {
                    e.preventDefault();
                    var anchorLink = $(this).attr("href");
                    var headerHeight = $("#header").outerHeight();
                    $("html, body").animate(
                        {
                            scrollTop:
                                $(anchorLink).offset().top - headerHeight,
                        },
                        2000
                    );
                });
            } else {
                $("body").removeClass("mobile_nav-fixed--true");
                $("body").addClass("mobile_nav-fixed--false");
            }
        }

        // Avoid cart_content duplicating for mobile screen sizes
        if ($("#header .cart_content").length < 1) {
            $("#header .cart-container").append(
                $(".header .cart_content").clone()
            );
        }
        var closeTimer = null;

        // Toggle mini-cart with menu icon
        if (window.PXUTheme.theme_settings.cart_action !== "redirect_cart") {
            $(".mini_cart").on("click ", function () {
                var $cartContainer = $(this).parent();
                if ($cartContainer.hasClass("active_link")) {
                    closeMiniCart();
                } else {
                    openMiniCart($cartContainer);
                }
            });
            $(".cart-container").on("mouseenter", function () {
                var $cartContainer = $(this);
                clearTimeout(closeTimer);
                openMiniCart($cartContainer);
            });
            $(".cart-container").on("mouseleave", function () {
                closeTimer = setTimeout(function () {
                    return closeMiniCart();
                }, 400);
            });
        }
        $(".cart_content__continue-shopping").on("click", function () {
            closeMiniCart();
        });
    },
    unload: function unload() {
        if (window.sticky_nav) {
            window.sticky_nav.destroy();
        }
        window.navigationDesktopManager.unload();
        window.mobileMenuDrawer.unload();
        $("body").off("click", ".mobile_nav");
        $("html").off("click");
        $(".cart-container").off("mouseenter");
        $(".cart-container").off("mouseleave");
        $(".mini_cart").off("click");
        $(".cart_content__continue-shopping").off("click");
        $("body").off("click", '.banner a[href^="#"]');
        $(".main-nav__wrapper.sticky_nav").remove();
    },
};
var Meganav = /*#__PURE__*/ (function () {
    function Meganav(el) {
        var options =
            arguments.length > 1 && arguments[1] !== undefined
                ? arguments[1]
                : {};
        _classCallCheck(this, Meganav);
        this.options = _objectSpread(
            {
                getTargets: function getTargets() {
                    return [];
                },
                afterChange: function afterChange() {},
            },
            options
        );
        this.content = el;
        this.targetHandle = this.content.dataset.meganavHandle;
        this.targets = this.options.getTargets({
            handle: this.targetHandle,
        });
        this.newMenuItems = [];
        if (!this.targets.length) return;
        this.refTarget = this.targets[0];
        this.title = this.refTarget.querySelector("[data-nav-title]").innerHTML;
        this.url = this._getUrl(this.refTarget);
        this.nav = this.refTarget.closest("[data-nav]");
        this.menuItemTemplate = this.nav.querySelector(
            "[data-nav-parent-template]"
        );
        this.inject();
    }
    _createClass(Meganav, [
        {
            key: "inject",
            value: function inject() {
                if (!this.targets.length) return;
                this._removeInjectedContent();
                var newMenuItem =
                    this.menuItemTemplate.content.firstElementChild.cloneNode(
                        true
                    );
                newMenuItem
                    .querySelector("[data-meganav-target-container]")
                    .appendChild(this.content.cloneNode(true));
                newMenuItem.querySelector("[data-nav-title]").innerHTML =
                    this.title;
                this._updateHref(newMenuItem, this.url);
                this.newMenuItems = Array.prototype.map.call(
                    this.targets,
                    function (target) {
                        var newItem = newMenuItem.cloneNode(true);
                        target.replaceWith(newItem);
                        return newItem;
                    }
                );
                this.options.afterChange();
            },
        },
        {
            key: "unload",
            value: function unload() {
                this._removeInjectedContent();
                this.options.afterChange();
            },
        },
        {
            key: "_updateHref",
            value: function _updateHref(target, url) {
                var dataHrefEl = target.querySelector("[data-href]");
                if (dataHrefEl) {
                    dataHrefEl.dataset.href = url;
                    return;
                }
                var a = target.querySelector("a");
                if (a) {
                    a.href = url;
                    return;
                }
            },
        },
        {
            key: "_getUrl",
            value: function _getUrl(target) {
                var dataHrefEl = target.querySelector("[data-href]");
                if (dataHrefEl) {
                    return dataHrefEl.dataset.href;
                }
                var a = target.querySelector("a");
                if (a) {
                    return a.href;
                }
                return "";
            },
        },
        {
            key: "_removeInjectedContent",
            value: function _removeInjectedContent() {
                var _this7 = this;
                this.newMenuItems.forEach(function (menuItem, i) {
                    menuItem.replaceWith(_this7.targets[i]);
                });
                this.newMenuItems = [];
            },
        },
    ]);
    return Meganav;
})();
var MeganavManager = /*#__PURE__*/ (function () {
    function MeganavManager() {
        _classCallCheck(this, MeganavManager);
        this.meganavs = new Map();
    }
    _createClass(MeganavManager, [
        {
            key: "select",
            value: function select(el) {
                if (!this.meganavs.get(el)) return;
                var _this$meganavs$get = this.meganavs.get(el),
                    desktop = _this$meganavs$get.desktop;
                desktop.newMenuItems.forEach(function (menuItem) {
                    window.navigationDesktopManager.onMeganavSelect(menuItem);
                });
            },
        },
        {
            key: "deselect",
            value: function deselect() {
                window.navigationDesktopManager.onMeganavDeselect();
            },
        },
        {
            key: "add",
            value: function add(el) {
                if (
                    !el.querySelector("[data-meganav-mobile]") ||
                    !el.querySelector("[data-meganav-desktop]")
                )
                    return;
                this.meganavs.set(el, {
                    mobile: new Meganav(
                        el.querySelector("[data-meganav-mobile]"),
                        {
                            getTargets: function getTargets(_ref4) {
                                var handle = _ref4.handle;
                                return document.querySelectorAll(
                                    '[data-meganav-mobile-target="'.concat(
                                        handle,
                                        '"]'
                                    )
                                );
                            },
                        }
                    ),
                    desktop: new Meganav(
                        el.querySelector("[data-meganav-desktop]"),
                        {
                            getTargets: function getTargets(_ref5) {
                                var handle = _ref5.handle;
                                return document.querySelectorAll(
                                    '[data-meganav-desktop-target="'.concat(
                                        handle,
                                        '"]'
                                    )
                                );
                            },
                            afterChange: function afterChange() {
                                return window.navigationDesktopManager.initAll();
                            },
                        }
                    ),
                });
            },
        },
        {
            key: "remove",
            value: function remove(el) {
                var meganav = this.meganavs.get(el);
                if (meganav) {
                    meganav.mobile.unload();
                    meganav.desktop.unload();
                    this.meganavs["delete"](el);
                }
            },
        },
        {
            key: "injectAll",
            value: function injectAll() {
                this.unload();
                this._addAll();
                var _iterator = _createForOfIteratorHelper(this.meganavs),
                    _step;
                try {
                    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                        var _step$value = _slicedToArray(_step.value, 2),
                            el = _step$value[0],
                            meganav = _step$value[1];
                        meganav.mobile.inject();
                        meganav.desktop.inject();
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally {
                    _iterator.f();
                }
            },
        },
        {
            key: "unload",
            value: function unload() {
                var _iterator2 = _createForOfIteratorHelper(this.meganavs),
                    _step2;
                try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                        var _step2$value = _slicedToArray(_step2.value, 2),
                            el = _step2$value[0],
                            meganav = _step2$value[1];
                        meganav.mobile.unload();
                        meganav.desktop.unload();
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally {
                    _iterator2.f();
                }
                this.meganavs.clear();
            },
        },
        {
            key: "_addAll",
            value: function _addAll() {
                var _this8 = this;
                document
                    .querySelectorAll(".shopify-section--mega-menu")
                    .forEach(function (meganavEl) {
                        if (_this8.meganavs.has(meganavEl)) return;
                        _this8.add(meganavEl);
                    });
            },
        },
    ]);
    return MeganavManager;
})();
window.meganavManager = new MeganavManager();

/*============================================================================
  Map
==============================================================================*/
window.map = {
    init: function init() {
        if ($(".lazymap").length > 0) {
            lazyframe(".lazymap");
        }
        if ($(".maps").hasClass("js-api-map")) {
            var mapsToLoad = [];
            // Create map settings array
            $(".map").each(function (i) {
                mapsToLoad.push(this);
                mapsToLoad[i].sectionid = $(this).data("id");
                mapsToLoad[i].address = $(this).data("address");
                mapsToLoad[i].directions = $(this).data("directions-address");
                mapsToLoad[i].zoom = $(this).data("zoom");
                mapsToLoad[i].mapstyle = $(this).data("style");
                mapsToLoad[i].showpin = $(this).data("pin");
                mapsToLoad[i].apikey = $(this).data("api-key");
            });
            $.each(mapsToLoad, function (i) {
                // Enable caching to avoid duplicate google maps files
                $.ajaxSetup({
                    cache: true,
                });
                // Load maps script and find location coordinates
                $.getScript(
                    "https://maps.googleapis.com/maps/api/js?key=".concat(
                        mapsToLoad[i].apikey
                    )
                ).then(function () {
                    window.map.findLocation(mapsToLoad[i]);
                    $.ajaxSetup({
                        cache: false,
                    });
                });
            });
        }
    },
    findLocation: function findLocation(mapArray) {
        var geoLat;
        var geoLng;
        var geocoder = new google.maps.Geocoder();
        // Find and set coordinates
        geocoder.geocode(
            {
                address: mapArray.dataset.address,
            },
            function (results, status) {
                if (status === google.maps.GeocoderStatus.OK) {
                    geoLat = results[0].geometry.location.lat();
                    geoLng = results[0].geometry.location.lng();
                    // Create map
                    window.map.initMap(geoLat, geoLng, mapArray);
                } else {
                    console.log("Error:".concat(status));
                }
            }
        );
    },
    initMap: function initMap(lat, lng, mapArray) {
        var location = {
            lat: lat,
            lng: lng,
        };
        var styleJson = [];
        // Set style JSON
        if (mapArray.mapstyle === "aubergine") {
            styleJson = [
                {
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#1d2c4d",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#8ec3b9",
                        },
                    ],
                },
                {
                    elementType: "labels.text.stroke",
                    stylers: [
                        {
                            color: "#1a3646",
                        },
                    ],
                },
                {
                    featureType: "administrative.country",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            color: "#4b6878",
                        },
                    ],
                },
                {
                    featureType: "administrative.land_parcel",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#64779e",
                        },
                    ],
                },
                {
                    featureType: "administrative.province",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            color: "#4b6878",
                        },
                    ],
                },
                {
                    featureType: "landscape.man_made",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            color: "#334e87",
                        },
                    ],
                },
                {
                    featureType: "landscape.natural",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#023e58",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#283d6a",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#6f9ba5",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "labels.text.stroke",
                    stylers: [
                        {
                            color: "#1d2c4d",
                        },
                    ],
                },
                {
                    featureType: "poi.park",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#023e58",
                        },
                    ],
                },
                {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#3C7680",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#304a7d",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#98a5be",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.text.stroke",
                    stylers: [
                        {
                            color: "#1d2c4d",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#2c6675",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            color: "#255763",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#b0d5ce",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "labels.text.stroke",
                    stylers: [
                        {
                            color: "#023e58",
                        },
                    ],
                },
                {
                    featureType: "transit",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#98a5be",
                        },
                    ],
                },
                {
                    featureType: "transit",
                    elementType: "labels.text.stroke",
                    stylers: [
                        {
                            color: "#1d2c4d",
                        },
                    ],
                },
                {
                    featureType: "transit.line",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#283d6a",
                        },
                    ],
                },
                {
                    featureType: "transit.station",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#3a4762",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#0e1626",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#4e6d70",
                        },
                    ],
                },
            ];
        } else if (mapArray.mapstyle === "retro") {
            styleJson = [
                {
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ebe3cd",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#523735",
                        },
                    ],
                },
                {
                    elementType: "labels.text.stroke",
                    stylers: [
                        {
                            color: "#f5f1e6",
                        },
                    ],
                },
                {
                    featureType: "administrative",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            color: "#c9b2a6",
                        },
                    ],
                },
                {
                    featureType: "administrative.land_parcel",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            color: "#dcd2be",
                        },
                    ],
                },
                {
                    featureType: "administrative.land_parcel",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#ae9e90",
                        },
                    ],
                },
                {
                    featureType: "landscape.natural",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#dfd2ae",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#dfd2ae",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#93817c",
                        },
                    ],
                },
                {
                    featureType: "poi.park",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#a5b076",
                        },
                    ],
                },
                {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#447530",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#f5f1e6",
                        },
                    ],
                },
                {
                    featureType: "road.arterial",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#fdfcf8",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#f8c967",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            color: "#e9bc62",
                        },
                    ],
                },
                {
                    featureType: "road.highway.controlled_access",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#e98d58",
                        },
                    ],
                },
                {
                    featureType: "road.highway.controlled_access",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            color: "#db8555",
                        },
                    ],
                },
                {
                    featureType: "road.local",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#806b63",
                        },
                    ],
                },
                {
                    featureType: "transit.line",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#dfd2ae",
                        },
                    ],
                },
                {
                    featureType: "transit.line",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#8f7d77",
                        },
                    ],
                },
                {
                    featureType: "transit.line",
                    elementType: "labels.text.stroke",
                    stylers: [
                        {
                            color: "#ebe3cd",
                        },
                    ],
                },
                {
                    featureType: "transit.station",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#dfd2ae",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#b9d3c2",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#92998d",
                        },
                    ],
                },
            ];
        } else if (mapArray.mapstyle === "silver") {
            styleJson = [
                {
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#f5f5f5",
                        },
                    ],
                },
                {
                    elementType: "labels.icon",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#616161",
                        },
                    ],
                },
                {
                    elementType: "labels.text.stroke",
                    stylers: [
                        {
                            color: "#f5f5f5",
                        },
                    ],
                },
                {
                    featureType: "administrative.land_parcel",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#bdbdbd",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#eeeeee",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#757575",
                        },
                    ],
                },
                {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#e5e5e5",
                        },
                    ],
                },
                {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#9e9e9e",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
                {
                    featureType: "road.arterial",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#757575",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#dadada",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#616161",
                        },
                    ],
                },
                {
                    featureType: "road.local",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#9e9e9e",
                        },
                    ],
                },
                {
                    featureType: "transit.line",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#e5e5e5",
                        },
                    ],
                },
                {
                    featureType: "transit.station",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#eeeeee",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#c9c9c9",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#9e9e9e",
                        },
                    ],
                },
            ];
        } else if (mapArray.mapstyle === "night") {
            styleJson = [
                {
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#242f3e",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#746855",
                        },
                    ],
                },
                {
                    elementType: "labels.text.stroke",
                    stylers: [
                        {
                            color: "#242f3e",
                        },
                    ],
                },
                {
                    featureType: "administrative.locality",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#d59563",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#d59563",
                        },
                    ],
                },
                {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#263c3f",
                        },
                    ],
                },
                {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#6b9a76",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#38414e",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            color: "#212a37",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#9ca5b3",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#746855",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            color: "#1f2835",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#f3d19c",
                        },
                    ],
                },
                {
                    featureType: "transit",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#2f3948",
                        },
                    ],
                },
                {
                    featureType: "transit.station",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#d59563",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#17263c",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#515c6d",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "labels.text.stroke",
                    stylers: [
                        {
                            color: "#17263c",
                        },
                    ],
                },
            ];
        } else {
            styleJson = [];
        }
        // Create google maps link
        $(".js-map-link").attr(
            "href",
            "https://www.google.com/maps/place/"
                .concat(mapArray.directions, "/@")
                .concat(lat, ",")
                .concat(lng)
        );
        // Set map options
        var mapOptions = {
            zoom: mapArray.zoom,
            center: location,
            styles: styleJson,
            disableDefaultUI: false,
        };
        // Create map
        var map = new google.maps.Map(
            document.getElementById(mapArray.sectionid),
            mapOptions
        );
        // Show pin
        if (mapArray.showpin === true) {
            var marker = new google.maps.Marker({
                position: location,
                map: map,
            });
        }
    },
};

/*============================================================================
  Shoppable Image
==============================================================================*/
window.shoppableImage = {
    init: function init() {
        var _this9 = this;
        $("[data-shoppable-image-wrapper]").each(function (_, wrapper) {
            var blocks = wrapper.querySelectorAll(
                "[data-shoppable-image-block]"
            );
            var currentImage = wrapper.querySelector("[data-shoppable-image]");

            // Only initialize slider if there is more than one shoppable image block added
            if (blocks.length > 1) {
                // sliderBlock utility function requires Flickity to be initialized with jQuery
                var $wrapper = $(wrapper);
                var settings = {
                    slideshowSpeed: $wrapper.data("slideshow-speed") * 1000,
                    slideshowTextAnimation: $wrapper.data(
                        "slideshow-text-animation"
                    ),
                    slideshowTransition: $wrapper.data("slideshow-transition"),
                };
                if (!$wrapper.hasClass("flickity-enabled")) {
                    $wrapper.flickity({
                        wrapAround: true,
                        cellAlign: "left",
                        imagesLoaded: true,
                        prevNextButtons: true,
                        draggable: true,
                        arrowShape: window.arrowSize,
                        pageDots: true,
                        autoPlay: settings.slideshowSpeed,
                        adaptiveHeight: true,
                    });

                    /*
            Move Flickity prev-next buttons to inside the shoppable image so
            that the buttons don't stretch beyond the shoppable image.
            We'll do this once on page load and then every time slides are changed.
          */
                    if (wrapper.querySelector(".shoppable-image__bottom-bar")) {
                        var prevNextBtns = wrapper.querySelectorAll(
                            ".flickity-prev-next-button"
                        );
                        var _currentImage = window.Flickity.data(
                            $wrapper[0]
                        ).selectedElement;
                        var currentShoppableImage = _currentImage.querySelector(
                            "[data-shoppable-image]"
                        );
                        prevNextBtns.forEach(function (btn) {
                            return $(btn).appendTo(currentShoppableImage);
                        });
                        $wrapper.on("change.flickity", function () {
                            var currentImage = window.Flickity.data(
                                $wrapper[0]
                            ).selectedElement;
                            var currentShoppableImage =
                                currentImage.querySelector(
                                    "[data-shoppable-image]"
                                );
                            prevNextBtns.forEach(function (btn) {
                                return $(btn).appendTo(currentShoppableImage);
                            });
                        });
                    }
                    if (settings.slideshowTextAnimation !== "") {
                        var flkty = $wrapper.data("flickity");
                        setTimeout(function () {
                            $wrapper
                                .find(
                                    ".gallery-cell:nth-child(1) [data-slideshow-caption-text]"
                                )
                                .addClass(
                                    "animated ".concat(
                                        settings.slideshowTextAnimation
                                    )
                                );
                        }, 400);
                        $wrapper.on("select.flickity", function () {
                            if ($wrapper.is(":visible")) {
                                var currentSlide = flkty.selectedIndex + 1;
                                setTimeout(function () {
                                    $wrapper
                                        .find("[data-slideshow-caption-text]")
                                        .removeClass(
                                            "animated ".concat(
                                                settings.slideshowTextAnimation
                                            )
                                        );
                                    $wrapper
                                        .find(
                                            ".gallery-cell:nth-child(".concat(
                                                currentSlide,
                                                ") [data-slideshow-caption-text]"
                                            )
                                        )
                                        .addClass(
                                            "animated ".concat(
                                                settings.slideshowTextAnimation
                                            )
                                        );
                                }, 400);
                            }
                        });
                    }

                    /*
            When using the slide transition, Flickity updates the positioning of its slides
            which can affect the positioning of the product cards on slide change.
            For fade transition we can just update the position once on page load.
            For slide transition we will update the position for the first slide on page load
            and when changing slides.
          */

                    if (
                        window.PXUTheme.media_queries.medium.matches &&
                        settings.slideshowTransition !== "fade"
                    ) {
                        var _flkty = $wrapper.data("flickity");
                        var currentSlide = _flkty.selectedIndex + 1;
                        var $hotspotEls = $wrapper.find(
                            ".gallery-cell:nth-child(".concat(
                                currentSlide,
                                ") [data-hotspot]"
                            )
                        );
                        $hotspotEls.each(function (_, hotspot) {
                            _this9.repositionHotspotContent(hotspot);
                        });
                        $wrapper.on("settle.flickity", function () {
                            var currentSlide = _flkty.selectedIndex + 1;
                            var $hotspotEls = $wrapper.find(
                                ".gallery-cell:nth-child(".concat(
                                    currentSlide,
                                    ") [data-hotspot]"
                                )
                            );
                            $hotspotEls.each(function (_, hotspot) {
                                _this9.repositionHotspotContent(hotspot);
                            });
                        });
                    } else {
                        _this9.repositionHotspotContentEls(currentImage);
                    }
                    $wrapper.on("settle.flickity", function () {
                        currentImage =
                            window.Flickity.data(wrapper).selectedElement;
                        _this9.repositionHotspotContentEls(currentImage);
                    });

                    // Add class to parent section so that sliderBlock utility is only called when slider enabled
                    var parentEl = wrapper.closest(
                        ".shopify-section--shoppable-image"
                    );
                    parentEl.classList.add(
                        "shopify-section--shoppable-image--slider-enabled"
                    );
                }
            } else {
                _this9.repositionHotspotContentEls(currentImage);
            }
            var interactiveEls = wrapper.querySelectorAll(
                "[data-interactive-element]"
            );

            /*
        Adds active state to hotspot and thumbnails
        When a hotspot is in focus, its linked thumbnail will also become active
        When a thumbnail is in focus, its linked hotspot will also become active
      */

            document.body.addEventListener("click", function (e) {
                var clickedInteractiveEl = e.target.closest(
                    "[data-interactive-element]"
                );
                interactiveEls.forEach(function (el, index) {
                    var block = el.closest("[data-shoppable-image-block]");
                    if (
                        clickedInteractiveEl &&
                        el.dataset.hotspotId ===
                            clickedInteractiveEl.dataset.hotspotId
                    ) {
                        block.classList.add(
                            el.dataset.hotspotId,
                            "hotspot--".concat(index + 1)
                        );
                        el.classList.add("has-active-state");
                    } else {
                        block.classList.remove(
                            el.dataset.hotspotId,
                            "hotspot--".concat(index + 1)
                        );
                        el.classList.remove("has-active-state");
                    }
                });
            });

            // Reposition hotspots' content when window is resized.
            window.addEventListener(
                "resize",
                _this9.debounce(function () {
                    _this9.repositionHotspotContentEls(currentImage);
                })
            );
        });
    },
    // Adjust content wrapper if it is outside of the viewport or shoppable image
    repositionHotspotContent: function repositionHotspotContent(hotspot) {
        var contentWrapperEl = hotspot.querySelector("[data-content-wrapper]");
        var contentEl = contentWrapperEl.querySelector("[data-content]");
        var shoppableImage = hotspot.closest("[data-shoppable-image]");

        // Reset styles
        contentWrapperEl.style.transform = "";
        contentWrapperEl.style.top = "";
        contentWrapperEl.style.bottom = "";
        var contentBounds = contentEl.getBoundingClientRect();
        var shoppableImageBounds = shoppableImage.getBoundingClientRect();
        var cssTop = window
            .getComputedStyle(contentWrapperEl)
            .getPropertyValue("padding");

        /*
      Prevent the hotspot content from going outside of the main shoppable image
      when the hotspot is placed too close to the top.
    */
        if (
            contentBounds.top < shoppableImageBounds.top &&
            !window.PXUTheme.media_queries.mobile_and_tablet.matches
        ) {
            contentWrapperEl.style.top = "-".concat(cssTop);
        }

        /*
      Prevent the hotspot content from going outside of the main shoppable image
      when the hotspot is placed too close to the bottom.
    */
        if (
            contentBounds.bottom > shoppableImageBounds.bottom &&
            !window.PXUTheme.media_queries.mobile_and_tablet.matches
        ) {
            contentWrapperEl.style.bottom = "-".concat(cssTop);
        }

        /*
      Prevent the hotspot content from going outside of the main shoppable image
      when the hotspot is placed too close to the right.
    */
        if (contentBounds.right > shoppableImageBounds.width) {
            contentWrapperEl.style.transform = "translateX(-100%)";
        }

        /*
      Prevent the hotspot content from going outside of the main shoppable image
      when the hotspot is placed too close to the left.
    */
        if (contentBounds.left < 0) {
            contentWrapperEl.style.transform = "translateX(0)";
        }
    },
    repositionHotspotContentEls: function repositionHotspotContentEls(
        currentSlide
    ) {
        var _this10 = this;
        var hotspotEls = currentSlide.querySelectorAll("[data-hotspot]");
        hotspotEls.forEach(function (hotspot) {
            return _this10.repositionHotspotContent(hotspot);
        });
    },
    debounce: function debounce(callback) {
        var timeout =
            arguments.length > 1 && arguments[1] !== undefined
                ? arguments[1]
                : 500;
        var timeoutId = null;
        return function () {
            for (
                var _len = arguments.length, args = new Array(_len), _key = 0;
                _key < _len;
                _key++
            ) {
                args[_key] = arguments[_key];
            }
            clearTimeout(timeoutId);
            timeoutId = setTimeout(function () {
                callback.apply(null, args);
            }, timeout);
        };
    },
    unload: function unload($target) {
        var $slider = $target.find("[data-shoppable-image-wrapper]");
        if ($slider.hasClass("flickity-enabled")) {
            $slider.flickity("destroy");
        }
    },
};
/*============================================================================
  Global accordions
==============================================================================*/
window.accordion = {
    init: function init() {
        var flg = 0;
        var $vanillaAccordion = $(".accordion");
        var $faqHeading = $(".faqAccordion > dt > button, .accordion > dt > a");
        $(".faqAccordion > dd, .accordion > dd").attr("aria-hidden", true);
        $faqHeading.attr("aria-expanded", false);
        $faqHeading.on("click activate", function () {
            if (flg) return false;
            flg = 1;
            var state =
                $(this).attr("aria-expanded") === "false" ? true : false;
            $(this).attr("aria-expanded", state);
            $(this)
                .parent()
                .next()
                .slideToggle(function () {
                    flg = 0;
                });
            $(this).parent().next().attr("aria-hidden", !state);
            return false;
        });
        $faqHeading.on("keydown", function (event) {
            var keyCode = event.keyCode || event.which;
            if (keyCode === 13) {
                $(this).trigger("activate");
            }
        });
        $vanillaAccordion.each(function (_, accordion) {
            var $accordion = $(accordion);
            if ($accordion.data("state") === "open") {
                $accordion.find($faqHeading[0]).parent().next().slideToggle();
                $accordion.find($faqHeading[0]).attr("aria-expanded", true);
            }
        });
    },
};

/*============================================================================
  Global shortcodes
==============================================================================*/
var ProductCTA = /*#__PURE__*/ (function (_HTMLElement) {
    _inherits(ProductCTA, _HTMLElement);
    var _super = _createSuper(ProductCTA);
    function ProductCTA() {
        var _this11;
        _classCallCheck(this, ProductCTA);
        // Always call super first in constructor
        _this11 = _super.call(this);

        // Create a shadow root
        _this11.attachShadow({
            mode: "open",
        }); // sets and returns 'this.shadowRoot'
        _this11.events = [];
        var forAttr = _this11.getAttribute("for");
        var variants = forAttr
            ? document.querySelector("#".concat(forAttr, " [data-variants]"))
            : null;
        var variantId = _this11.getAttribute("variantid");
        var appendto = document.querySelector(_this11.getAttribute("appendto"));
        if (!variants || !variantId) {
            _this11._setVisible(false);
            return _possibleConstructorReturn(_this11);
        }
        if (appendto) {
            appendto.appendChild(_assertThisInitialized(_this11));
        }

        // Remove element from DOM and insert new element into position
        _this11._registerEvent({
            el: variants,
            event: "change",
            listener: function listener(e) {
                return _this11._onVariantChange(e, variantId);
            },
        });
        _this11._setVisible(variants.value === _this11.variantId);
        return _this11;
    }
    _createClass(
        ProductCTA,
        [
            {
                key: "connectedCallback",
                value: function connectedCallback() {
                    var href = this.getAttribute("href") || "#";
                    var target = this.getAttribute("target");
                    var style = document.createElement("style");
                    var a = document.createElement("a");
                    var slot = document.createElement("slot");
                    style.innerHTML =
                        "\n      a {\n        color: inherit;\n        cursor; inherit;\n        text-decoration: inherit;\n      }\n    ";
                    a.href = href;
                    a.target = target;
                    a.appendChild(slot);
                    if (target === "_blank") {
                        var icon = document.createElement("span");
                        icon.classList.add("button-icon");
                        icon.setAttribute("aria-label", "(New window)");
                        icon.innerHTML =
                            '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.81792 2.29812L5.68732 5.42884L6.57121 6.3127L9.70198 3.18183L9.70227 5.51933L10.9523 5.51917L10.9518 1.67302L10.9517 1.0481L10.3268 1.0481L6.48062 1.04815L6.48064 2.29815L8.81792 2.29812ZM1.67297 1.04817H1.04797V1.67317V10.327V10.952H1.67297H10.3268H10.9518V10.327V8.13026H9.70175V9.70195H2.29797V2.29817H3.83642V1.04817H1.67297Z" fill="currentColor"/></svg>';

                        // attach the created elements to the shadow DOM
                        a.appendChild(icon);
                    }
                    this.shadowRoot.append(style, a);
                },
            },
            {
                key: "disconnectedCallback",
                value: function disconnectedCallback() {
                    this.events.forEach(function (_ref6) {
                        var el = _ref6.el,
                            event = _ref6.event,
                            listener = _ref6.listener;
                        return el.removeEventListener(event, listener);
                    });
                    this.shadowRoot.innerHTML = "";
                    this._setVisible(true);
                },
            },
            {
                key: "_registerEvent",
                value: function _registerEvent(_ref7) {
                    var el = _ref7.el,
                        event = _ref7.event,
                        listener = _ref7.listener;
                    this.events.push({
                        el: el,
                        event: event,
                        listener: listener,
                    });
                    el.addEventListener(event, listener);
                    return {
                        el: el,
                        event: event,
                        listener: listener,
                    };
                },
            },
            {
                key: "_setVisible",
                value: function _setVisible(visible) {
                    this.toggleAttribute("hidden", !visible);
                },
            },
            {
                key: "_onVariantChange",
                value: function _onVariantChange(e, variantId) {
                    this._setVisible(e.currentTarget.value === variantId);
                },
            },
        ],
        [
            {
                key: "shortcode",
                get: function get() {
                    return "product-cta";
                },
            },
        ]
    );
    return ProductCTA;
})(/*#__PURE__*/ _wrapNativeSuper(HTMLElement));
customElements.define(ProductCTA.shortcode, ProductCTA);
